export default {
    title: {
        KPIDashboard: 'KPI Dashboard',
        BannerImageManagement: 'Banner Image Management',
        GpsTracking: 'GPS Tracking',
        EventCalendar: 'Event Calendar',
        EventList: 'Event List',
        Calendar: 'Calendar',
        VehicleFilter: 'Vehicle Filter',
        FullMapTracking: 'Real-Time Tracking Map',
        LiveVideo: 'Live Video',
        VideoDownloadCenter: 'Video Download Center',
        MultiVehicleTracking: 'Multi Vehicle Tracking',
        VehicleTrackingList: 'Vehicle Tracking List',
        VehicleSummary: 'Vehicle Summary (Vehicle Tracking List)',
        HistoricalPlayback: 'Historical Playback',
        HistoricalPlaybackDetails: 'Historical Playback Details',
        PtoLog: 'PTO Log',
        PoiManagement: 'POI Management',
        AddPOIForm: 'Add POI Form',
        EditPOIForm: 'Edit POI Form',
        GeofenceManagement: 'Geofence Management',
        Vehicle: 'Vehicle',
        ManageVehicle: 'Manage Vehicle',
        PrintQRs: 'Print QR(s)',
        PrintVehicleQRs: 'Print Vehicle QR(s)',
        MaintenanceProfile: 'Maintenance Profile',
        MaintenanceLog: 'Maintenance',
        Overview: 'Overview',
        ServiceLog: 'Service Log',
        VehicleLog: 'Vehicle Documentation Log',
        MaintenanceForm: 'Maintenance Form',
        AddMaintenanceForm: 'Add Maintenance Form',
        EditMaintenanceForm: 'Edit Maintenance Form',
        ViewMaintenanceForm: 'View Maintenance Form',
        Tools: 'Tools',
        MaintenanceCategory: 'Maintenance Category',
        Driver: 'Driver',
        ManageDriver: 'Manage Driver',
        ManageDriverForm: 'Driver Form',
        AddDriverForm: 'Add Driver Form',
        EditDriverForm: 'Edit Driver Form',
        DriverDetails: 'Driver Details',
        DriverInquiry: 'Driver Inquiry',
        DriverApp: 'Driver App',
        CheckInOut: 'Check In / Out',
        ChecklistApproval: 'Checklist Approval',
        DriverClaimReport: 'Driver Claim Report',
        DriverTracing: 'Driver Tracing',
        Trailer: 'Trailer',
        ManageTrailer: 'Manage Trailer',
        AddTrailerForm: 'Add Trailer Form',
        EditTrailerForm: 'Edit Trailer Form',
        TrailerTrackingPage: 'Trailer Tracking Page',
        FuelManagement: 'Fuel Management',
        FuelLog: 'Fuel Log',
        FuelConsumptionHistory: 'Fuel Consumption History',
        RefuelManagement: 'Refuel Management',
        FuelPriceManagement: 'Fuel Price Management',
        FuelSpend: 'Fuel Spend',
        FleetAccessSettings: 'Fleet Access Settings',
        FleetGroupForm: 'Fleet Group Form',
        AddFleetGroupForm: 'Add Fleet Group Form',
        EditFleetGroupForm: 'Edit Fleet Group Form',
        ManageUser: 'Manage User',
        UserForm: 'User Form',
        AddUserForm: 'Add User Form',
        EditUserForm: 'Edit User Form',
        FleetGroupManagement: 'Fleet Group Management',
        CompanyManagement: 'Company Management',
        CompanyForm: 'Company Form',
        AddCompanyForm: 'Add Company Form',
        EditCompanyForm: 'Edit Company Form',
        EmailNotificationSettings: 'Email Notification Settings',
        EmailNotificationSettingsForm: 'Email Notification Settings Form',
        NotificationSettings: 'Notification Settings',
        NotificationSettingsForm: 'Notification Settings Form',
        AddEmailNotificationSettingsForm: 'Add Email Notification Settings Form',
        EditEmailNotificationSettingsForm: 'Edit Email Notification Settings Form',
        RolesManagement: 'Roles Management',
        RolesForm: 'Roles Form',
        AddRolesForm: 'Add Roles Form',
        EditRolesForm: 'Edit Roles Form',
        PackageManagement: 'Package Management',
        PackageForm: 'Package Form',
        AddPackageForm: 'Add Package Form',
        EditPackageForm: 'Edit Package Form',
        AuditLogs: 'Audit Logs',
        Report: 'Report',
        VehicleIndustry: 'Vehicle Industry',
        VehicleForm: 'Vehicle Form',
        AddVehicleForm: 'Add Vehicle Form',
        EditVehicleForm: 'Edit Vehicle Form',
        ManageTracker: 'Manage Tracker',
        TrackerForm: 'Tracker Form',
        AddTrackerForm: 'Add Tracker Form',
        EditTrackerForm: 'Edit Tracker Form',
        MapInstance: 'Map Instance',
        MapInstanceDetails: 'Map Instance Details',
        UserSettings: 'User Settings',
        UserProfile: 'User Profile',
        HelpCenter: 'Help Center',
        ContactUs: 'Contact Us',
        Documentation: 'Documentation',
        DeviceSettings: 'Device Settings',
        FirmwareManagement: 'Firmware Management',
        AlarmHistory: 'Alarm History',
        AlarmDetails: 'Alarm Details',
        Notification: 'Notification',
        Checklist: 'Checklist',
        ManageChecklist: 'Manage Checklist',
        ChecklistTemplate: 'Checklist Template',
        ManageChecklistForm: 'Checklist Form',
        AddChecklistForm: 'Add Checklist Form',
        EditChecklistForm: 'Edit Checklist Form',
        CompanyChecklist: 'Company Checklist',
        BreakdownSupport: 'Breakdown Support',
        ManageWorkshop: 'Manage Workshop',
        ManageWorkshopForm: 'Manage Workshop Form',
        AddWorkshopForm: 'Add Workshop Form',
        EditWorkshopForm: 'Edit Workshop Form',
        ManageWorkshopRating: 'Manage Workshop Rating',
        SmartAnalytics: 'Smart Analytics',
        OperationalPerformance: 'Operational Performance',
        VehiclePerformance: 'Vehicle Performance',
        DriverPerformance: 'Driver Performance',
        ColdChainMonitoring: 'Cold Chain Monitoring',
        Toll: 'Toll',
        ManageToll: 'Manage Toll',
        ManageTollGroup: 'Manage Toll Group',
        TollGroupForm: 'Toll Group Form',
        Insurance: 'Insurance',
        Safety: 'Safety',
        EventDetails: 'Event Detail',
        Speeding: 'Speeding',
        Route: 'Route',
        ManageRoute: 'Manage Route',
        ManageRouteDetail: 'Route',
        EditManageRouteDetail: 'Edit Route',
        ManageRouteGroup: 'Manage Group Route',
        RouteGroupForm: 'Add New Route Group',
        RouteGroupDetail: 'Route Group',
        AssignRouteGroup: 'Assign Route Group',
        FullMapTrackingLite: 'Full Map Tracking',
        RealTimeTrackingGroup: 'Real Time Tracking (Group)',
        VehicleTrackingListLite: 'Vehicle Tracking List',
        ManageRouteForm: 'Manage Route Form',
        ManageLite: 'Manage Lite',
        LiteUserForm: 'Lite User Form',
        AddLiteUserForm: 'Add Lite User Form',
        EditLiteUserForm: 'Edit Lite User Form',
        Alert: 'Alert',
        ServiceRecord: 'Service Record',
        CreateNewServiceRecord: 'Create New Service Record',
        EditServiceRecord: 'Edit Service Record',
        ServiceDetails: 'Service Details',
        ManagePeripheral: 'Manage Peripheral',
        PeripheralDevice: 'Peripheral Device',
        ApiIntegration: 'API Integration',
        AddPeripheralDeviceForm: 'Add Peripheral Device Form',
        EditPeripheralDeviceForm: 'Edit Peripheral Device Form',
        AdvanceSafety: 'Advanced AI Safety Dashboard',
        SafetyEvent: 'Safety Events',
        SafetyDashboard: 'Safety Dashboard',
        VehiclePerformanceDetails: 'Vehicle Performance Details',
        DriverPerformanceDetails: 'Driver Performance Details',
        Add_Company_Form: 'Add Company Form',
        Edit_Company_Form: 'Edit Company Form',
        delete_company: "Delete Company",
        CreateNewChecklistTemplate: 'Create New Checklist Template',
        EditChecklistTemplate: 'Edit Checklist Template',
        DriverCareDashboard: 'Driver Care+ Dashboard',
        DriverCare: 'Driver Care+',
        SafetyMonitoring: 'Safety Monitoring Board',
        AiSafetyMonitoring: 'AI Safety Monitoring Board',
        AddDriverConfiguration: 'Add Driver Configuration',
        EditDriverConfiguration: 'Edit Driver Configuration',
        ChecklistItem: 'Checklist Item',
        DriverConfiguration: 'Driver Configuration',
        ManageSuppliers: 'Manage Suppliers',
        ViewDriverConfiguration: 'View Driver Configuration',
        ManageItemCode: 'Manage Item Code',
        ManageCheckpoint: 'Manage Checkpoint',
        EditCheckpoint: 'Edit Checkpoint',
        ManageSharableLinkList: 'Manage Shareable Link List',
        CreateRefuelRecord: 'Create Refuel Record',
        EditRefuelRecord: 'Edit Refuel Record',
        RefuelImport: 'Refuel Import',
        FuelSpendDriverDetail: 'Fuel Spend Driver Detail',
        FuelSpendVehicleDetail: 'Fuel Spend Vehicle Detail',
        FuelSpendDriver: 'Fuel Spend (Driver)',
        FuelSpendVehicle: 'Fuel Spend (Vehicle)',
        TwoFactorAuthentication_2FA: 'Two-Factor Authentication (2FA)',
        VideoHistoricalPlayback: 'Video Historical Playback',
        GreenFleetDashboard: 'Green Fleet Dashboard',
        InternalCombustionEngineVehicles: 'Internal Combustion Engine Vehicles',
        APIKeyManagement: 'API Key Management',
        VideoReplay: 'Video Replay',
        Trips: 'Trips',
        FuelCalibrationForm: 'Fuel Calibration Form',
        UserManual: 'User Manual',
        IotConfigurator: 'IOT Configurator',
        MonitoringBoard: 'Monitoring Board',
        DeviceManager: 'Device Manager',
        PredictiveMaint: 'Predictive Maint.',
        RulesEngine: 'Rules Engine',
        RemoteConfig: 'Remote Config',
        AccidentReconstructionDashboard: 'Accident Reconstruction Dashboard',
        AccidentReconstructionDetails: 'Accident Reconstruction Details',
        IVMSParameters: 'IVMS Parameters',
        DrivingHour: 'Driving Hour',
        VehicleDiagnosis: 'Vehicle Diagnosis',
        AdvanceRoute: 'Advance Route',
        TripDetail: 'Trip Detail',
    },
    genderType: {
        MALE: 'Male',
        FEMALE: 'Female',
        male: 'Male',
        female: 'Female',
        3: 'Rather Not Say'
    },
    employmentStatus: {
        1: 'Active',
    },
    driverType: {
        DIRECT: 'Direct Driver',
        FEEDER: 'Feeder Driver'
    },
    approvalStatus: {
        1: 'Approved',
        2: 'Rejected',
        3: 'Pending'
    },
    serviceType: {
        1: 'Normal',
        2: 'Urgent',
        3: 'Warranty',
        4: 'Servicing',
        5: 'Troubleshooting',
        6: 'Puspakom',
        7: 'Accident',
        8: 'Total Lost',
        9: 'Engine Overhaul',
        10: 'Tyre',
        11: 'Service + Puspakom'
    },
    rateStatus: {
        1: 'Excellent',
        2: 'Good',
        3: 'Acceptable'
    },
    portable: 'Portable',
    portableType: {
        0: 'General',
        1: 'Portable Device',
        2: 'Trailer Tied'
    },
    vehicleStatus: {
        null: 'Working',
        parking: 'Parking',
        accident: 'Accident',
        deviceNotOnline: 'Device Not Online',
        repair: 'Repair',
        immobilized: 'Immobilized',
        suspendedSim: 'Suspended (SIM)'
    },
    integrationType: {
        vehicle: 'Vehicle',
        user: 'User',
        group: 'Fleet Group'
    },
    faq: {
        dashboard_question_1: "What is KPI Dashboard?",
        dashboard_answer_1: "KPI Dashboard allows user to have a brief details on vehicles and drives. Information that are available in this page are No. of Today Active Vehicle, Maintenance Alert, Suspicious Activity, No. of Alerts, Chart of Daily Utilization of Vehicles, Fuel Usage &amp; Mileage, Top 5 list of Idling Time, Fuel Consumption, High Speed.",
        dashboard_question_2: "What are the information shows in the 'No. of Today Active Vehicle'?",
        dashboard_answer_2: "'No. of Today Active Vehicle' shows the total number of active vehicle today out of the total number of vehicles registered in the system. In its detailed view, there will be a list of active vehicles including the plate number and the mileage of the vehicle.",
        dashboard_question_3: "What are the information shows in the 'Suspicious Activity?",
        dashboard_answer_3: "'Suspicious Activity' shows the details of suspicious activities detected on vehicles. The suspicious activity can be assign to be handle by user or other staffs through email address.",
        dashboard_question_4: "What are the information show in the 'Maintenance Alert'?",
        dashboard_answer_4: "'Maintenance Alert' shows the details of upcoming maintenance of vehicle. The maintenance alert can be assign to be handle by user or other staffs through email address.",
        dashboard_question_5: "How To Change Time Frame for KPI Dashboard Reports?",
        dashboard_answer_5: "To change the period of time of the KPI Dashboard's reports, click on the drop down list 'Yesterday' and select the time frame from 'Yesterday', 'Last 7 days', 'This Week', 'Last 30 Days', and 'This Month', then press 'Search' button on the right.",
        event_calendar_question_1: "What is Event Calendar?",
        event_calendar_answer_1: "Event Calendar summarize the expiration date such as insurance, permit, road tax and etc. in a calendar. It provides a more simple view that enables user to keep track on the upcoming events in a simpler way.",
        event_calendar_question_2: "Where Can I Get the Details of the Event?",
        event_calendar_answer_2: "To get the details of the event, click on the event and it will shows a list of vehicle that are involved in the event. Click on the vehicle number will redirect you to the vehicle details where all the information are listed.",
        gps_tracking_question_1: "Where is the Vehicle Current Location?",
        gps_tracking_answer_1: "Go to 'GPS Tracking' > 'Vehicles Tracking List'. Select and click on the registration number of vehicle to track the vehicle from the list.",
        gps_tracking_question_2: "How to Track Multiple Vehicle in a Single Page?",
        gps_tracking_answer_2: "Go to 'GPS Tracking' > 'Multi-Vehicle Tracking'. Select the registration number of vehicle to track the vehicle from the drop-down list. User can be track up to 4 vehicles in a single page.",
        gps_tracking_question_3: "How to Filter Vehicle by Groups?",
        gps_tracking_answer_3: "To filter vehicle by groups, press '-Please select a group-' drop down list. Pick a group then press 'Search' on the right to process the filtering.",
        gps_tracking_question_4: "How to Find the Location of a Coordinate or an Address?",
        gps_tracking_answer_4: "To look for the location of a coordinate or an address, just click on the address or coordinate. The location will then be shown in Google Map.",
        gps_tracking_question_5: "Where Can I Track All Vehicles Registered?",
        gps_tracking_answer_5: "It is possible to track all available vehicles by go to 'GPS Tracking' > 'Full Vehicle Tracking Map'.",
        gps_tracking_question_6: "How to View the Whole Journey of a Vehicle in a Day?",
        gps_tracking_answer_6: "Go to 'GPS Tracking' > 'Historical Playback' and select the vehicle registration number to be tracked. Next, select the date and time and desire playback speed before clicking 'Search' button. After the playback started, click on the 'Full Track' on the right panel to display the full track.",
        vehicle_question_1: "Where and How to Add New Vehicle?",
        vehicle_answer_1: "Go to 'Vehicle' > 'Add new vehicle', enter the information required for the form and press 'Submit.",
        vehicle_question_2: "Where and How to Manage Vehicle?",
        vehicle_answer_2: "Go to 'Vehicle' > 'Manage vehicles', select a vehicle to be edited. Enter the updated information of the vehicle into the form and press 'Save'.",
        vehicle_question_3: "Where Can I Get Vehicle Maintenance Log?",
        vehicle_answer_3: "Go to 'Vehicle' > 'Vehicle Maintenance Log', all the information of the vehicle will be listed in a table.",
        vehicle_question_4: "Where Can I Download/Print Vehicle Maintenance Log?",
        vehicle_answer_4: "Go to 'Vehicle' > 'Vehicle Maintenance Log', on the right top corner there will be 'CSV', 'Excel', 'PDF' format that are available for download and a 'Print' to print the Vehicle Maintenance Log.",
        driver_question_1: "Where and How to Add New Driver?",
        driver_answer_1: "Go to 'Driver' > 'Add new driver', enter the information required for the form and press 'Submit.",
        driver_question_2: "Where and How to Manage Driver?",
        driver_answer_2: "Go to 'Driver' > 'Manage Drivers', select a driver to be edited and press 'Edit Profile' on the top right. Enter the updated information of the driver into the form and press 'Save.",
        driver_question_3: "Where Can I Get Driver Log?",
        driver_answer_3: "Go to 'Driver' > 'Driver Log', the information of the will be listed in a table.",
        fleet_access_setting_question_1: "Where to Add and Manage Users and Fleet Groups?",
        fleet_access_setting_answer_1: "Go to 'Fleet Access Settings' and go to the specific user group management. Then select to Add or Manage the user group. Follow the instructions and fill in the details needed.",
        fuel_management_question_1: "Where Can I Review Fuel Consumption Report of A Vehicle?",
        fuel_management_answer_1: "Go to 'Fuel Management' > 'Fuel Consumption Report', select a vehicle and press 'Search'. All the information of the fuel consumption of the vehicle will be shown in a table below.",
        fuel_management_question_2: "Where Can I Review Refuel Report of Vehicles?",
        fuel_management_answer_2: "Go to 'Fuel Management' > 'Refuel Report', the table below will list the refuel details of vehicles, sorted from the lastest by default.",
        fuel_management_question_3: "How to Narrow Down the Refuel Report of a Specific Vehicle?",
        fuel_management_answer_3: "Go to 'Fuel Management' > 'Refuel Report', Select the vehicle registration number and also the specific time range then press the 'Search' button. The table below will shows all the Refuel information of the vehicle in the specific time period.",
        report_question_1: "How to Download a Report?",
        report_answer_1: "Reports are able to be downloaded by pressing 'Export' or 'Export Full Report' on the right top corner of the view. By default, the reports are in excel format.",
        report_question_2: "How Can I Download Report to Another Format?",
        report_answer_2: "To download a report in other format, press the 'CSV' ,'Excel' ,or 'PDF' shown on the top right corner of the report details.",
        report_question_3: "How Can I Print a Report?",
        report_answer_3: "To print a report, press the 'Print' shown on the top right corner of the report details.",
    },
    geofenceModule: {
        checkpoint: 'Checkpoint',
        checkpointwithoutnotification: 'Checkpoint Without Notification',
        prohibited: 'Prohibited',
        inout: 'In/Out',
        in: 'In',
        out: 'Out',
        color: {
            null: 'Default',
            black: 'Black',
            gray: 'Gray',
            red: 'Red',
            crimson: 'Crimson',
            blue: 'Blue',
            cyan: 'Cyan',
            olive: 'Olive',
            green: 'Green',
            lime: 'Lime',
            yellow: 'Yellow',
            orange: 'Orange',
            salmon: 'Salmon',
            purple: 'Purple',
        }
    },
    title_text: 'Title',
    please_enter_username: 'Please Enter Username',
    please_enter_password: 'Please Enter Password',
    login: 'Login',
    logout: 'Logout',
    switchLang: 'Switch Language',
    permit_sah: 'Permit Sah',
    minyak_engine: 'Minyak Engine',
    Jan: 'January',
    Feb: 'February',
    Mar: 'March',
    Apr: 'April',
    May: 'May',
    Jun: 'June',
    Jul: 'July',
    Aug: 'August',
    Sep: 'September',
    Oct: 'October',
    Nov: 'November',
    Dec: 'December',
    no_data: 'No Data',
    start_date: 'Start Date',
    start_time: 'Start Time',
    display_start_date: 'Display Start Date',
    display_priority: 'Display Priority',
    display_priority_validation: 'Display priority must be between 1 and 5',
    priority_increases_with_number_1_to_5: 'Priority increases with number 1 to 5',
    end_date: 'End Date',
    display_end_date: 'Display End Date',
    end_time: 'End Time',
    playback_the_track_when_speed: 'Playback the track when speed >=',
    filter: 'Filter',
    add: 'Add',
    new: 'New',
    edit: 'Edit',
    toll: 'Toll',
    edit_profile: 'Edit Profile',
    back: 'Back',
    cancel: 'Cancel',
    cancel_action: 'Cancel Action',
    delete: 'Delete',
    are_you_sure_delete: 'Are you sure to delete <b>{name}</b>',
    are_you_sure_resend_command_for: 'Are you sure to resend command for <b>{name}</b>',
    are_you_sure_resend_all_command: 'Are you sure to resend all command',
    are_you_sure_cancel_all_command: 'Are you sure to cancel all command',
    save: 'Save',
    search: 'Search',
    apply: 'Apply',
    clear_all: 'Clear All',
    select_all: 'Select All',
    select_all_vehicles: 'Select All Vehicles',
    deselect_all: 'Deselect All',
    draft: 'Draft',
    completed: 'Completed',
    reset: 'Reset',
    export: 'Export',
    export_log: 'Export Log',
    exporting_log: 'Exporting log...',
    no_driving_record_data: 'No driving record data found for this event.',
    exporting: 'Exporting...',
    exporting_please_wait: 'Please wait while the PDF is being generated.',
    column: 'Columns',
    action: 'Action',
    total: 'Total',
    online: 'Online',
    offline: 'Offline',
    active: 'Active',
    inactive: 'Inactive',
    deactive: 'Deactive',
    select_a_group: 'Select a Group',
    select_a_vehicle: 'Select a Vehicle',
    select_a_vehicle_type: 'Select a Vehicle Type',
    select_a_engine_type: 'Select a Engine Type',
    select_a_plate_no: 'Select a Plate No',
    select_a_toll_name: 'Select a Toll Name',
    select_driver: 'Select Driver',
    toll_name: 'Toll Name',
    name: 'Name',
    summary: 'Summary',
    plate_no: 'Plate No.',
    date_start: 'Date Start',
    date_end: 'Date End',
    total_record: 'Total Record',
    acc_count: 'Acc Count',
    idling_count: 'Idling Count',
    not_located_count: 'Not Located Count',
    blind_area_reupload_count: 'Blind Area Reupload Count',
    abnormal_speed_count: 'Abnormal Speed Count',
    abnormal_max_speed: 'Abnormal Max Speed',
    abnormal_min_speed: 'Abnormal Min Speed',
    plate_no_driver_name: 'Plate No / Driver Name',
    registration_plate_no: 'Registration Plate No',
    plate_no_label: 'Plate No Label',
    tied_trailer: 'Tied Trailer',
    driver: 'Driver',
    new_driver: 'New Driver',
    group: 'Group',
    device_id: 'Device ID',
    sim_card_no: 'Sim Card No',
    card_no: 'Card No',
    registration_date: 'Registration Date',
    installation_date: 'Installation Date',
    warranty_installation_date: 'Warranty Installation Date',
    fuel_consumption: 'Fuel Consumption',
    car_utilization: 'Car Utilization',
    safety_level: 'Safety Level',
    group_name: 'Group Name',
    ignition: 'Ignition',
    first_drive: 'First Drive',
    pto: 'PTO',
    pto_1_settings: 'PTO 1 Settings',
    pto_2: 'PTO 2',
    pto_2_settings: 'PTO 2 Settings',
    compartment_temperature_sensor_position_settings: 'Compartment Temperature Sensor Position Settings',
    front_sensor_position: 'Front Sensor Position',
    rear_sensor_position: 'Rear Sensor Position',
    status_raw: 'Status (Raw)',
    display_to_customer: 'Display to Customer',
    reverse_invert_display: 'Reverse (Invert Display)',
    when_enabled_status_shown_reversed: 'When enabled, the status shown to customer will be reversed',
    door_sensor: 'Door Sensor',
    door_sensor_2: 'Door Sensor 2',
    temperatures: 'Temperatures',
    time: 'Time',
    idle_duration: 'Idle Duration',
    speed: 'Speed',
    device_status: 'Device Status',
    mdvr_status: 'SafeVision Status',
    no_issue: 'No issue',
    fuel: 'Fuel',
    today_mileage: 'Today Mileage',
    address: 'Address',
    custom_view: 'Custom View',
    set_stop_duration: 'Set Stop Duration',
    full_map: 'Full Map',
    date_time: 'Date Time',
    fuel_level: 'Fuel Level',
    acc: 'Acc',
    mileage_km: 'Mileage (KM)',
    start_point: 'Start Point',
    end_point: 'End Point',
    starting_mileage: 'Starting Mileage',
    location: 'Location',
    idling_duration: 'Idling Duration',
    parking_duration: 'Parking Duration',
    nombor: 'No.',
    daily_summary: 'Daily Summary',
    live_tracking: 'Live Tracking',
    view_profile: 'View Profile',
    fuel_report: 'Fuel Report',
    pto_log: 'PTO Log',
    maintenance_log: 'Maintenance Log',
    stop_recover_engine: 'Stop Recover Engine',
    assign_unassign_driver: 'Assign/Unassign Driver',
    assign_unassign_tng_card: 'Assign/Unassign TNG Card',
    create_sharable_view: 'Create Shareable View',
    live_video: 'Live Video',
    status: 'Status',
    engine_type: 'Engine Type',
    vehicle_type: 'Vehicle Type',
    normal: 'Normal',
    idling: 'Idling',
    parking: 'Parking',
    contact: 'Contact',
    phone_no: 'Phone Number',
    vehicle: 'Vehicle',
    poi: 'POI',
    traffic: 'Traffic',
    geofence: 'Geofence',
    search_by_plate_no: 'Search by Plate Number',
    search_by_poi: 'Search by POI Name',
    search_by_checkpoint: 'Search by Checkpoint Name',
    search_by_geofence: 'Search by Geofence Name',
    all: 'All',
    moving: 'Moving',
    disconnected: 'Disconnected',
    geofence_entry_ot: 'Geofence Entry OT',
    speeding: 'Speeding',
    ICE: 'Internal Combustion Engine (ICE)',
    PHEV: 'Plug-in Hybrid Electric Vehicle (PHEV)',
    EV: 'Electric Vehicle (EV)',
    car: 'Car',
    bus: 'Bus',
    truck: 'Truck',
    machinery: 'Machinery',
    machinery_crane: 'Machinery',
    mixer: 'Mixer Truck',
    van: 'Van',
    crane: 'Crane',
    motor: 'Motorcycle',
    strong: 'Strong',
    medium: 'Medium',
    weak: 'Weak',
    healthy: 'Healthy',
    aware: 'Aware',
    abnormal: 'Abnormal',
    'open circuit': 'Open Circuit',
    'short circuit': 'Short Circuit',
    unknown: 'Unknown',
    need_replacement: 'Need replacement',
    full_charge: 'Full Charge',
    charging: 'Charging',
    low_charge: 'Low Charge',
    and_above: 'and above',
    and_below: 'and below',
    engine_service_date: 'Engine Service Date',
    transmission_gear_box_service_date: 'Transmission / Gear Box Service Date',
    electrical_system_service_date: 'Electrical System Service Date',
    please_select_vehicle: 'Please select vehicle first...',
    please_select_driver: 'Please select driver first...',
    please_select_date: 'Please select date',
    please_select_group_or_vehicle: 'Please select group or vehicle',
    please_select_filters_first: 'Please select filters first',
    show_route: 'Show Route',
    hide_route: 'Hide Route',
    live_data: 'Live Data',
    maintenance: 'Maintenance',
    add_poi: 'Add POI',
    edit_poi: 'Edit POI',
    poi_details: 'POI Details',
    poi_name: 'POI Name',
    poi_latitude: 'POI Latitude',
    poi_longitude: 'POI Longitude',
    poi_icon: 'POI Icon',
    poi_radius: 'POI Radius',
    poi_contacter: 'POI Contacter',
    poi_phone: 'POI Phone',
    poi_address: 'POI Address',
    poi_remark: 'POI Remark',
    checkpoint_name: 'Checkpoint Name',
    checkpoint_latitude: 'Checkpoint Latitude',
    checkpoint_longitude: 'Checkpoint Longitude',
    checkpoint_icon: 'Checkpoint Icon',
    checkpoint_radius: 'Checkpoint Radius',
    checkpoint_type: 'Checkpoint Type',
    base: 'Base',
    station: 'Station',
    terminal: 'Terminal',
    checkpoint_remark: 'Checkpoint Remark',
    checkpoint_address_1: 'Checkpoint Address Line 1',
    checkpoint_address_2: 'Checkpoint Address Line 2',
    checkpoint_address_3: 'Checkpoint Address Line 3',
    checkpoint_contact_name: 'Checkpoint Contact Name',
    checkpoint_contact_no: 'Checkpoint Contact No',
    total_cost: 'Total Cost',
    total_spend: 'Total Spend',
    code: 'Code',
    description: 'Description',
    maintenance_category: 'Maintenance Category',
    maintenance_form: 'Maintenance Form',
    form_no: 'Form No',
    workshop: 'Workshop',
    contact_no: 'Contact No',
    contact_name: 'Contact Name',
    service_type: 'Service Type',
    cost_of_repair_rm: 'Cost of Repair (RM)',
    urgent: 'Urgent',
    warranty: 'Warranty',
    servicing: 'Servicing',
    troubleshooting: 'Troubleshooting',
    puspakom: 'Puspakom',
    accident: 'Accident',
    total_lost: 'Total Lost',
    engine_overhaul: 'Engine Overhaul',
    tyre: 'Tyre',
    maintenance_form_details: 'Maintenance Form Details',
    repair_maintenance_order: 'Repair Maintenance Order',
    vehicle_condition_remark: 'Vehicle Condition Remark',
    please_enter: 'Please enter...',
    please_select: 'Please select',
    partnership_workshop: 'Partnership Workshop',
    drive_in_date_time: 'Drive In Datetime',
    drive_out_date_time: 'Drive Out Datetime',
    technician: 'Technician',
    drop_off_driver: 'Drop Off Driver',
    pickup_driver: 'Pickup Driver',
    estimate_complete_date: 'Estimate Complete Date',
    item: 'Item',
    good: 'Good',
    front_head_lamps: 'Front Head Lamps',
    rear_tails_lamps: 'Rear Tails Lamps',
    adjust_brake_pm_trailer: 'Adjust Brake PM / Trailer',
    brake_pm_trailer: 'Brake PM Trailer',
    top_up_engine_oil: 'Top Up Engine Oil',
    top_up_aircond_gas: 'Top Up Aircond Gas',
    rear_front_view_mirror: 'Rear Front View Mirror',
    air_leaking: 'Air Leaking',
    windscreen: 'Windscreen',
    both_side_windows: 'Both Side Windows',
    wiring_problem: 'Wiring Problem',
    gear_problem: 'Gear Problem',
    wiper_blade: 'Wiper Blade',
    permit_date: 'Permit Date',
    roadtax_date: 'Roadtax Date',
    sgp_roadtax_date: 'SGP Roadtax Date',
    puspakom_date: 'Puspakom Date',
    insurance_date: 'Insurance Date',
    service_date: 'Service Date',
    service_due_date: 'Service Due Date',
    remaining_mileage: 'Remaining Mileage',
    service_log: 'Service Log',
    vehicle_log: 'Vehicle Log',
    view_all: 'View All',
    category: 'Category',
    type: 'Type',
    last_service_mileage: 'Last Service Mileage',
    next_date: 'Next Date',
    current_mileage: 'Current Mileage',
    affordable_mileage: 'Affordable Mileage',
    spare_part_cost: 'Spare Part Cost',
    labour_cost: 'Labour Cost',
    supplier: 'Supplier',
    service: 'Service',
    last_service_date: 'Last Service Date',
    remark: 'Remark',
    service_details: 'Service Details',
    mark_as_done: 'Mark As Done',
    details: 'Details',
    history: 'History',
    categories: 'Categories',
    maintenance_type: 'Maintenance Type',
    date: 'Date',
    spare_cost: 'Spare Cost',
    payment_date: 'Payment Date',
    driver_name: 'Driver Name',
    license_no: 'License No',
    license_expiry_date: 'License Expiry Date',
    psv_expiry_date: 'PSV Expiry Date',
    permit_expiry_date: 'Permit Expiry Date',
    gdl_expiry_date: 'GDL Expiry Date',
    company: 'Company',
    created_by: 'Created by',
    created_at: 'Created At',
    last_updated: 'Last Updated',
    last_updated_at: 'Last Updated at {time}',
    last_location: 'Last Location',
    check_in_time: 'Check In Time',
    check_out_list: 'Check Out List',
    driver_list: 'Driver List',
    all_driver_list: 'All Driver List',
    driver_type: 'Driver Type',
    check_in_date_time: 'Check In Date / Time',
    check_out_date_time: 'Check Out Date / Time',
    forced_check_out: 'Forced Check Out',
    checklist_no: 'Checklist No',
    today_checked_in: 'Today Checked In',
    today_checked_out: 'Today Checked Out',
    checked_in: 'Checked In',
    checked_out: 'Checked Out',
    last_7_days: 'Last 7 days',
    today_total_checklist: 'Today Total Checklist',
    driver_without_checklist: 'Driver Without Checklist',
    vehicle_without_checklist: 'Vehicle Without Checklist',
    failed_item_no: 'Failed Item No',
    verify_by: 'Verify By',
    verify_at: 'Verify At',
    verify: 'Verify',
    driver_claim_overview: 'Driver Claim Overview',
    last_30_days: 'Last 30 days',
    total_claim: 'Total Claim',
    total_petrol_claim: 'Total Petrol Claim',
    toll_claim: 'Toll Claim',
    total_toll_claim: 'Total Toll Claim',
    total_number_of_driver: 'Total Number of Driver',
    petrol_claim: 'Petrol Claim',
    petrol_toll_claim: 'Petrol Toll Claim',
    today: 'Today',
    yesterday: 'Yesterday',
    last_week: 'Last Week',
    last_month: 'Last Month',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    driver_claim_history: 'Driver Claim History',
    toll_claim_rm: 'Toll Claim (RM)',
    petrol_claim_rm: 'Petrol Claim (RM)',
    total_cost_rm: 'Total Cost (RM)',
    driver_claim_profile: 'Driver Claim Profile',
    claim_date: 'Claim Date',
    reviewed_by: 'Reviewed By',
    reviewed_date: 'Reviewed Date',
    attachment: 'Attachment',
    attachments: 'Attachments',
    review: 'Review',
    reject: 'Reject',
    approve: 'Approve',
    point_to_point_distance: 'Point to Point Distance',
    point: 'Point',
    add_point: 'Add Point',
    calculate: 'Calculate',
    duration: 'Duration',
    pto_status: 'PTO Status',
    on: 'On',
    off: 'Off',
    on_cap: 'ON',
    off_cap: 'OFF',
    index: 'Index',
    geofence_instance_name: 'Geofence Instance Name',
    number_of_geofence: 'Number Of Geofence',
    creator: 'Creator',
    manage: 'Manage',
    device_integration: 'Device Integration',
    geofence_details: 'Geofence Details',
    trailer_no: 'Trailer No',
    roadtax_expiry_date: 'Roadtax Expiry Date',
    sgp_roadtax_expiry_date: 'SGP Roadtax Expiry Date',
    sgp_expiry_date: 'SGP Expiry Date',
    puspakom_expiry_date: 'Puspakom Expiry Date',
    insurance_start_date: 'Insurance Start Date',
    insurance_expiry_date: 'Insurance Expiry Date',
    pma_expiry_date: 'PMA Expiry Date',
    trailer: 'Trailer',
    trailer_profile: 'Trailer Profile',
    trailer_details: 'Trailer Details',
    roadtax_no: 'Roadtax No',
    singapore_roadtax_no: 'Singapore Roadtax No',
    singapore_roadtax_expiry_date: 'Singapore Roadtax Expiry Date',
    puspakom_no: 'Puspakom No',
    insurance_no: 'Insurance No',
    pma_no: 'PMA No',
    insurance_sum_assured_rm: 'Insurance Sum Assured (RM)',
    assigned_prime_mover: 'Assigned Prime Mover',
    rfid_no: 'RFID No',
    total_active_vehicle: 'Total Active Vehicle',
    total_vehicle: 'Total Vehicle',
    suspicious_activity: 'Suspicious Activity',
    maintenance_notification: 'Maintenance Notification',
    no_of_alert: 'No. of Alert',
    expenses: 'Expenses',
    fuel_usage_mileage: 'Fuel Usage & Mileage',
    last_update_on: 'Last Update On {date}',
    environment_gas_emission: 'Environment Gas Emission',
    table_of_environment_gas_emission: 'Table Of Environment Gas Emission',
    environment_gas_emission_report: 'Environment Gas Emission Report',
    month: 'Month',
    co2_kg: 'CO<sub>2</sub> (kg)',
    ch2_gms: 'CH<sub>2</sub> (gms)',
    so2_gms: 'SO<sub>2</sub> (gms)',
    no2_gms: 'NO<sub>X</sub> (gms)',
    pm_gms: 'PM (gms)',
    hc_gms: 'HC (gms)',
    compare_to_last_month: 'compare to last month',
    from_previous_month: 'from previous month',
    total_mileage_km: 'Total Mileage (km)',
    total_travel_time: 'Total Travel Time',
    total_idling_duration: 'Total Idling Duration',
    fuel_economy: 'Fuel Economy',
    chart_of_daily_utilization_of_vehicles: 'Chart Of Daily Utilization Of Vehicles',
    summary_report_list: 'Summary Report List',
    vehicle_report_list: 'Vehicle Report List',
    driver_report_list: 'Driver Report List',
    vehicle_active_report: 'Vehicle Active Report',
    overall_fleet_fuel_avg_economy: 'Overall Fleet Fuel Avg Economy',
    ok: 'Ok',
    offline_for_1_2_days: 'Offline for 1-2 Days',
    offline_for_3_4_days: 'Offline for 3-4 Days',
    'offline_for_5+_days': 'Offline for 5+ Days',
    not_active: 'Not Active',
    'good_0.050km_0.1km_l': 'Good - 0.050km - 0.1km/l',
    'medium_0.050km_0.1km_l': 'Medium - 0.050km - 0.1km/l',
    'alert_0.050km_0.1km_l': 'Alert - 0.050km - 0.1km/l',
    top5_idling_time: 'Top 5 Idling Time',
    top5_high_speed: 'Top 5 High Speed',
    top5_high_fuel_consumption: 'Top 5 High Fuel Consumption',
    top5_fuel_economy: 'Top 5 Fuel Economy',
    driver_score: 'Driver Score',
    average_driver_score: 'Average Driver Score',
    driver_status: 'Driver Status',
    top5_safety_driver: 'Top 5 Safety Drivers',
    top5_high_risk_driver: 'Top 5 High Risk Drivers',
    excellent: 'Excellent',
    fair: 'Fair',
    critical: 'Critical',
    high: 'High',
    distance_km: 'Distance/km',
    active_driver: 'Active Driver',
    event: 'Event',
    no_of_vehicles: 'No. of Vehicles',
    utilized_vehicles: 'Utilized Vehicles',
    kilometer: 'Kilometer',
    liter: 'Liter',
    fuel_usage: 'Fuel Usage',
    mileage: 'Mileage',
    trips: 'Trips',
    vehicle_performance: 'Vehicle Performance',
    driver_app: 'Driver App',
    advanced_safety: 'Advanced Safety',
    safety: 'Safety',
    spend: 'Spend',
    operator: 'Operator',
    alert: 'Alert',
    diagnosis: 'Diagnosis',
    all_vehicle_summary_report: 'All Vehicle Summary Report',
    monthly_vehicle_mileage_report: 'Monthly Vehicle Mileage Report',
    vehicle_status_log: 'Vehicle Status Log',
    vehicle_usage_report: 'Vehicle Usage Report',
    trips_report: 'Trips Report',
    geofence_report: 'Geofence Report',
    poi_report: 'POI Report',
    machinery_summary_report: 'Machinery Summary Report',
    maintenance_log_report: 'Maintenance Log Report',
    idling_summary_report: 'Idling Summary Report',
    raw_data_report: 'Raw Data Report',
    engine_report: 'Engine Report',
    temperature_chart: 'Temperature Chart',
    temperature: 'Temperature',
    pto_camera_report: 'PTO Camera Report',
    rotation_report: 'Rotation Report',
    driving_record_report: 'Driving Record Report',
    trailer_log_report: 'Trailer Log Report',
    trailer_raw_report: 'Trailer Raw Report',
    driver_summary_report: 'Driver Summary Report',
    driver_logs_report: 'Driver Logs Report',
    driver_trips_report: 'Driver Trips Report',
    driver_activity_report: 'Driver Activity Report',
    driver_activity_summary_report: 'Driver Activity Summary Report',
    driver_violation_report: 'Driver Violation Report (SBS)',
    driver_debriefing_report: 'Driver Debriefing Report',
    driver_trip_summary_report: 'Driver Trip Summary Report',
    driver_unauthorized_stop_report: 'Driver Unauthorized Stop Report',
    driver_driving_behaviour_violation_report: 'Driver Driving Behaviour Violation Report',
    violation_datetime: 'Violation Datetime',
    violation_duration: 'Violation Duration',
    start_datetime: 'Start Datetime',
    end_datetime: 'End Datetime',
    start_location: 'Start Location',
    end_location: 'End Location',
    drive_time: 'Drive Time',
    idle_time: 'Idle Time',
    overspeed: 'Overspeed',
    overspeed_type: 'Overspeed Type',
    max_speed: 'Max Speed',
    driver_score_report: 'Driver Score Report',
    driver_safety_report: 'Driver Safety Report',
    driver_safety_behaviour_report: 'Driver Safety Behaviour Report',
    driver_job_report: 'Driver Job Report',
    get_checklist_report: 'Get Checklist Report',
    vehicle_safety_report: 'Vehicle Safety Report',
    fatigue_photo_video_report: 'Fatigue Photo Video Report',
    fatigue_monitor_board: 'Fatigue Monitor Board',
    fatigue_driving_record: 'Fatigue Driving Record',
    toll_report: 'Toll Report',
    fuel_drop_report: 'Fuel Drop Report',
    refuel_summary_report: 'Refuel Summary Report',
    mileage_liter_by_statement: 'Mileage/Liter By Statement',
    operator_company_daily_report: 'Operator Company Daily Report',
    operator_attendance_report: 'Operator Attendance Report',
    operator_driver_report: 'Operator Driver Report',
    suspicious_activity_report: 'Suspicious Activity Report',
    critical_alert_report: 'Critical Alert Report',
    alert_report: 'Alert Report',
    maintenance_alert_report: 'Maintenance Alert Report',
    vehicle_diagnosis_report: 'Vehicle Diagnosis Report',
    speed_report: 'Speed Report',
    overspeed_record_report: 'Overspeed Record Report',
    report: 'Report',
    yes: 'Yes',
    no: 'No',
    item_for_inspection: 'Item For Inspection',
    minyak_power_setting: 'Minyak Power Setting',
    recently_viewed: 'Recently Viewed',
    starred: 'Starred',
    idling_time_min: 'Idling Time (Min)',
    report_type: 'Report Type',
    customize_column: 'Customize Column',
    fleet: 'Fleet',
    max_speed_km_h: 'Max Speed (KM/H)',
    fuel_usage_l: 'Fuel Usage (L)',
    fuel_cost_rm: 'Fuel Cost (RM)',
    refuel_amount_l: 'Refuel Amount (L)',
    km_l: 'KM/L',
    fuel_efficiency_perc: 'Fuel Efficiency (%)',
    fuel_consumption_km_l: 'Fuel Consumption (KM/L)',
    total_idle_duration: 'Total Idle Duration',
    unallowed_idle_duration: 'Unallowed Idle Duration',
    idling_fuel_usage_l: 'Idling Fuel Usage (L)',
    idle_cost_rm: 'Idle Cost (RM)',
    total_driving_duration: 'Total Driving Duration',
    total_journey_time: 'Total Journey Time',
    avg_daily_speed_km_h: 'Avg. Daily Speed (KM/H)',
    data_summaries: 'Data Summaries',
    vehicle_summaries: 'Vehicle Summaries',
    data_details: 'Data Details',
    data_summary: 'Data Summary',
    profile_info: 'Profile Info',
    training_record: 'Training Record',
    violation_record: 'Violation Record',
    driver_detail: 'Driver Detail',
    driver_details: 'Driver Details',
    staff_id: 'Staff ID',
    tel_no_hp: 'Tel No. (hp)',
    date_of_birth: 'Date Of Birth',
    emergency_contact: 'Emergency Contact',
    working_position: 'Working Position',
    nric: 'NRIC',
    email: 'Email',
    gender: 'Gender',
    password: 'Password',
    nationality: 'Nationality',
    rental_fee: 'Rental Fee',
    other_information: 'Other Information',
    other_informations: 'Other Informations',
    driving_license_no: 'Driving License No',
    driving_license_expiry_date: 'Driving License Expiry Date',
    commercial_license_no_gdl: 'Commercial License No (GDL)',
    comm_license_no_expiry_date: 'Comm. License No Expiry Date',
    permit_no: 'Permit No',
    psv_no: 'PSV No',
    psv_license_expire: 'PSV License Expire',
    hired_date: 'Hired Date',
    salary: 'Salary',
    bank: 'Bank',
    bank_acc: 'Bank Acc',
    bank_acc_no: 'Bank Acc No',
    assign_to: 'Assign To',
    employment_status: 'Employment Status',
    permanent: 'Permanent',
    note: 'Note',
    ic_license_upload: 'IC & License Upload',
    ic: 'IC',
    driving_license: 'Driving License',
    comm_license_gdl: 'Comm. License (GDL)',
    training_title: 'Training Title',
    attended_date: 'Attended Date',
    expiry_date: 'Expiry Date',
    cost: 'Cost',
    cost_rm: 'Cost (RM)',
    compulsory: 'Compulsory',
    violation_type: 'Violation Type',
    violation_date: 'Violation Date',
    fine: 'Fine',
    fine_rm: 'Fine (RM)',
    pay_by: 'Pay By',
    other_details: 'Other Details',
    driver_apps_credential: 'Driver Care+ Apps Credential',
    pick_your_birthday: 'Pick Your Birthday',
    male: 'Male',
    female: 'Female',
    next: 'Next',
    previous: 'Previous',
    malaysian: 'Malaysian',
    non_malaysian: 'Non Malaysian',
    direct_driver: 'Driver Driver',
    feeder_driver: 'Feeder Driver',
    comm_license: 'Comm. License',
    please_ignore_it_if_not_applicable: '* Please Ignore It If Not Applicable',
    username: 'Username',
    assign_to_supervisor: 'Assign To Supervisor',
    supervisor: 'Supervisor',
    route_group: 'Route Group',
    route_in_charge: 'Route In Charge',
    trip_details: 'Trip Details',
    historical_playback: 'Historical Playback',
    alert_log: 'Alert Log',
    avg_speed: 'Avg Speed',
    activities: 'Activities',
    driver_distance: 'Driver Distance',
    violation: 'Violation',
    device_type: 'Device Type',
    protocol_type: 'Protocol Type',
    color: 'Color',
    manufacturer_model: 'Manufacturer Model',
    chasis_no: 'Chasis No',
    owned_sub_con: 'Owned/Sub-Con',
    capacity: 'Capacity',
    capacity_unit: 'Capacity Unit',
    tng_no: 'TNG No',
    fleet_card_no: 'Fleet Card No',
    tank_no: 'Tank No',
    electrical_system: 'Electrical System',
    vehicle_details: 'Vehicle Details',
    new_vehicle_industry: 'New Vehicle Industry',
    vehicle_industry: 'Vehicle Industry',
    speed_limit_km_h: 'Speed Limit (km/h)',
    allowing_idling_time: 'Allowing Idling Time',
    operation_hour_per_week_hrs: 'Operation Hour Per Week (hrs)',
    main_road_condition: 'Main Road Condition',
    good_type: 'Good Type',
    estimated_overload_perc: 'Estimated Overload (%)',
    idling_alert_setting: 'Idling Alert Setting',
    idling_minutes: 'Idling Minutes',
    please_leave_blank_for_using_the_default_idling_setting: '* Please leave blank for using the default idling setting',
    minutes: 'Minutes',
    low_fuel_alert_setting: 'Low Fuel Alert Setting',
    low_fuel_percentage: 'Low Fuel Percentage',
    please_leave_blank_for_using_the_default_low_fuel_setting: '* Please leave blank for using the default low fuel setting',
    low_fuel_critical_alert: 'Low Fuel Critical Alert',
    fuel_drop_percentage: 'Fuel Drop Percentage',
    please_leave_blank_for_using_the_default_fuel_drop_setting: '* Please leave blank for using the default fuel drop setting',
    please_leave_blank_for_using_the_default_fuel_efficiency: '* Please leave blank for using the default fuel efficiency',
    please_leave_blank_for_using_the_default_best_in_class_fuel_efficiency: '* Please leave blank for using the default best in class fuel efficiency',
    please_leave_blank_for_using_the_default_fuel_waste_rate: '* Please leave blank for using the default fuel waste rate',
    please_leave_blank_for_using_the_default_minimum_refuel_detection: '* Please leave blank for using the default minimum refuel detection',
    prohibit_driving_periods: 'Prohibit Driving Periods',
    add_new_prohibit_period: 'Add New Prohibit Period',
    remove_all: 'Remove All',
    document_due_date_reminder: 'Document Due Date Reminder',
    reminder_date: 'Reminder Date',
    vehicle_documents: 'Vehicle Documents',
    registration_certificate: 'Registration Certificate',
    fuel_history: 'Fuel History',
    today_active_inactive_vehicle: 'Today Active & Inactive Vehicle',
    distance: 'Distance',
    maintenance_alert_reminder: 'Maintenance Alert / Reminder',
    past_checklist: 'Past Checklist',
    today_checklist: 'Today Checklist',
    section: 'Section',
    na: 'N/A',
    click_to_upload: 'Click To Upload',
    vehicle_profile: 'Vehicle Profile',
    vehicle_report: 'Vehicle Report',
    chassis_no: 'Chassis No',
    fuel_rate: 'Fuel Rate',
    toll_class: 'Toll Class',
    oil_volume: 'Oil Volume',
    tyre_management: 'Tyre Management',
    qr_code: 'QR Code',
    print_vehicle_qrs: 'Print Vehicle QR(s)',
    print_selected: 'Print Selected',
    certificate: 'Certificate',
    oil_measurement_setting: 'Oil Measurement Setting',
    total_fuel_usage: 'Total Fuel Usage',
    average_fuel_consumption: 'Average Fuel Consumption',
    tyres_healthy_level: 'Tyres Healthy Level',
    vehicle_utilization: 'Vehicle Utilization',
    vehicle_safety_level: 'Vehicle Safety Level',
    cost_per_km: 'Cost Per Km',
    cpk_value_rm: 'CPK Value (RM)',
    upcoming: 'Upcoming',
    overdue: 'Overdue',
    group_average_fuel_performance: 'Group Average Fuel Performance',
    ltr_fuel_waste_when_idling: '{val} ltr fuel waste when idling',
    engine: 'Engine',
    next_service_date: 'Next Service Date',
    remaining_km: 'Remaining km',
    next_km: 'Next km',
    last_km: 'Last km',
    tyre_maintenance_log: 'Tyre Maintenance Log',
    updated_at: 'Updated At',
    updated_by: 'Updated By',
    view_detail: 'View Detail',
    installed_date: 'Installed Date',
    tread_depth: 'Tread Depth',
    sn: 'S/N',
    tyre_pressure: 'Tyre Pressure',
    brand: 'Brand',
    used_km: 'Used km',
    model: 'Model',
    estimated_remaining_km: 'Estimated Remaining km',
    size: 'Size',
    cooling_system: 'Cooling System',
    transmission_gear_box: 'Transmission/Gear Box',
    braking: 'Braking',
    body: 'Body',
    other: 'Other',
    add_new_record: 'Add New Record',
    vehicle_kpi: 'Vehicle KPI',
    permit: 'Permit',
    roadtax: 'Roadtax',
    sgp_roadtax: 'SGP Roadtax',
    insurance: 'Insurance',
    expired_soon: 'Expired Soon',
    expired: 'Expired',
    expired_date: 'Expired Date',
    add_new_instance: 'Add New Instance',
    new_instance: 'New Instance',
    geofence_list: 'Geofence List',
    integration_type: 'Integration Type',
    add_geofence: 'Add Geofence',
    add_new_geofence: 'Add New Geofence',
    edit_geofence: 'Edit Geofence',
    zone_type: 'Zone Type',
    zone_shape: 'Zone Shape',
    circle: 'Circle',
    polygon: 'Polygon',
    mode: 'Mode',
    stop_type: 'Stop Type',
    overtime_minute: 'Overtime (Minute)',
    check_point: 'Check Point',
    check_point_without_notification: 'Check Point Without Notification',
    prohibited: 'Prohibited',
    in_region: 'In Region',
    out_region: 'Out Region',
    in_out_region: 'In/Out Region',
    events: 'Events',
    driving_distance: 'Driving Distance',
    remaining: 'Remaining',
    days: 'Days',
    day: 'Day',
    documentation_log: 'Documentation Log',
    documentation: 'Documentation',
    machinery_tracking: 'Machinery Tracking',
    safety_equipment: 'Safety Equipment',
    equipment: 'Equipment',
    update_documentation_log: 'Update Documentation Log',
    update_machinery_tracking: 'Update Machinery Tracking',
    update_equipment: 'Update Equipment',
    update_other: 'Update Other',
    update_safety_equipment: 'Update Safety Equipment',
    engine_on_date: 'Engine On Date',
    engine_on_remaining_duration_hours: 'Engine On Remaining Duration (Hours)',
    fire_extinguisher_expiry_date: 'Fire Extinguisher Expiry Date',
    tanker_calibration_expiry_date: 'Tanker Calibration Expiry Date',
    permit_no_expiry_date: 'Permit No (Expiry Date)',
    roadtax_no_expiry_date: 'Roadtax No (Expiry Date)',
    singapore_roadtax_no_expiry_date: 'Singapore Roadtax No (Expiry Date)',
    puspakom_receipt_no_expiry_date: 'Puspakom Receipt No (Expiry Date)',
    insurance_sum_assured: 'Insurance Sum Assured',
    upload_by_time: 'Uploaded by {name} at {time}',
    fuel_price: 'Fuel Price',
    default_price_rm: 'Default Price (RM)',
    default: 'Default',
    default_rate: 'Default Rate',
    enter_rate: 'Enter Rate',
    predefine: 'Predefine',
    please_enter_code: 'Please Enter Code',
    please_enter_description: 'Please Enter Description',
    please_enter_default_rate: "Please Enter Default Rate",
    please_enter_correct_rate: "Please Enter Correct Rate",
    please_complete_all_rate_details: "Please Complete All Rate Details",
    new_fuel_price: "New Fuel Price",
    create_fuel_price: "Create Fuel Price",
    update_fuel_price: "Update Fuel Price",
    delete_fuel_price: "Delete Fuel Price",
    success: "Success",
    error: "Error",
    new_maintenance_category: "New Maintenance Category",
    create_maintenance_category: "Create Maintenance Category",
    update_maintenance_category: "Update Maintenance Category",
    delete_maintenance_category: 'Delete Maintenance Category',
    speed_limit: "Speed Limit",
    max_idling_duration: "Max Idling Duration",
    operation_hour_per_week: "Operation Hour Per Week",
    goods_type: "Goods Type",
    estimated_overload: "Estimated Overload",
    km: 'km',
    km_h: 'km/h',
    mins: 'mins',
    hrs: 'hrs',
    perc: '%',
    kg: 'kg',
    lbs: 'lbs',
    l_100km: 'ℓ/100km',
    hour_s: 'Hour(s)',
    l_idling_min: 'ℓ/idling minute',
    l: 'ℓ',
    please_enter_speed_limit: "Please Enter Speed Limit",
    please_enter_max_idling_duration: "Please Enter Max Idling Duration",
    please_enter_operation_hour_per_week: "Please Enter Operation Hour Per Week",
    please_enter_estimated_overload: "Please Enter Estimated Overload",
    please_select_road_condition: "Please Select Road Condition",
    please_enter_goods_type: "Please Enter Goods Type",
    general_road: "General Road",
    highway: "Highway",
    fleet_group_name: "Fleet Group Name",
    fleet_group: "Fleet Group",
    fleet_group_details: "Fleet Group Details",
    add_emergency_contact: "Add Emergency Contact",
    emergency_contact_person: "Emergency Contact Person",
    emergency_contact_number: "Emergency Contact Number",
    emergency_response_plan_setting: "Emergency Response Plan Setting",
    erp_contact_person: "ERP Contact Person",
    erp_contact_no: "ERP Contact Number",
    please_enter_fleet_group_name: "Please Enter Fleet Group Name",
    please_enter_contact_person_name: "Please Enter Contact Person Name",
    please_enter_contact_number: "Please Enter Contact Number",
    please_enter_correct_contact_number: "Please Enter Correct Contact Number",
    please_complete_emergency_contact_details: "Please Complete Emergency Contact Details",
    please_enter_correct_erp_contact_number: "Please Enter Correct ERP Contact Number",
    basic_information: "Basic Information",
    privacy_information: "Privacy Information",
    advance_information: "Advance Information",
    geotab_integration: "Geotab Integration",
    geotab_server: "Geotab Server",
    geotab_database: "Geotab Database",
    geotab_username: "Geotab Username",
    geotab_password: "Geotab Password",
    apad_gateway_integration: "Apad Gateway Integration",
    api_key: "API Key",
    api_password: "API Password",
    sovy_driver_preinspection_check_integration: "Sovy Driver Preinspection Check Integration",
    sovy_username: "Sovy Username",
    sovy_password: "Sovy Password",
    api_link: "API Link",
    company_id: "Company ID",
    branch_id: "Branch ID",
    idle_setting: "Idle Setting",
    vehicle_listing: "Vehicle Listing",
    enter_vehicle: "Enter Vehicle",
    selected_vehicle: "Selected Vehicle",
    no_vehicle: "No Vehicle",
    new_vehicle: "New Vehicle",
    everyday: "Everyday",
    weekday: "Weekday",
    weekend: "Weekend",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    update_service_log: "Update Service Log",
    create_service_log: "Create Service Log",
    delete_maintenance: "Delete Maintenance",
    create_fleet_group: "Create Fleet Group",
    update_fleet_group: "Update Fleet Group",
    delete_fleet_group: "Delete Fleet Group",
    tracker_details: "Tracker Details",
    tracker: "Tracker",
    new_tracker: "New Tracker",
    please_select_tracker: "Please Select Tracker",
    class_1_toll: 'CLASS 1 (Vehicles with 2 axies and 3 or 4 wheels excluding taxis)',
    class_2_toll: 'CLASS 2 (Vehicles with 2 axies and 5 or 6 wheels excluding buses)',
    class_3_toll: 'CLASS 3 (Vehicles with 3 or more axies)',
    class_4_toll: 'CLASS 4 (Taxi)',
    class_5_toll: 'CLASS 5 (Bus)',
    class_1_penang_toll: 'CLASS 1 (Motorcycles)',
    class_2_penang_toll: 'CLASS 2 (Commercial vehicle having 3 wheels and Car inclusive station wago)',
    class_3_penang_toll: 'CLASS 3 (Lorry and van having 2 axies and 4 wheels and Bus having 2 axies and 4 wheels)',
    class_4_penang_toll: 'CLASS 4 (Lorry and van having 2 axies and 5 or 6 wheels and Bus having 2 axies and 5 or 6 wheels)',
    class_5_penang_toll: 'CLASS 5 (Vehicles / Bus having 3 axies)',
    class_6_penang_toll: 'CLASS 6 (Vehicles having 4 axies)',
    class_7_penang_toll: 'CLASS 7 (Vehicles having 5 axies or more)',
    tyre_setting: 'Tyre Setting',
    tyre_maintenance: 'Tyre Maintenance',
    esg_setting: 'ESG Setting',
    esg_module: 'ESG Module',
    fuel_benchmark_setting: 'Fuel Benchmark Setting',
    fuel_efficiency: "Fuel Efficiency",
    fuel_wastage_rate: "Fuel Wastage Rate",
    toll_setting: "Toll Setting",
    penang_bridge_class: "Penang Bridge Class",
    mpob_integration: "MPOB Integration",
    mpob_device_id: "MPOB Device Id",
    cargomove_integration: 'CargoMove Integration',
    cargomove_plate_no: 'CargoMove Plate No',
    lpj_integration: 'LPJ Integration',
    lpj_plate_no: 'LPJ Plate No',
    migration_settings: 'Migration Settings',
    migration_server: 'Migration Server',
    migration_cutoff_date: 'Migration Cutoff Date',
    migration_plate_no: 'Migration Plate No',
    please_select_migration_server: 'Please select migration server',
    please_select_migration_cutoff_date: 'Please select migration cutoff date',
    upload: 'Upload',
    reupload: 'Reupload',
    download: 'Download',
    are_you_sure_you_want_to_upload: 'Are you sure you want to upload: ',
    tank_info: 'Tank Info',
    driver_reference: 'Driver Reference',
    driver_2: 'Driver 2',
    region: 'Region',
    transport_type: 'Transport Type',
    display_details: 'Display Details',
    vehicle_icon: 'Vehicle Icon',
    marker_image: 'Marker Image',
    oil_setting: 'Oil Setting',
    fuel_price_selection: 'Fuel Price Selection',
    engine_hour_setting: 'Engine Hour Setting',
    engine_hour_meter: 'Engine Hour Meter',
    system_calculated_engine_hour: 'System Calculated Engine Hour',
    adjust_to_engine_hour: 'Adjust To Engine Hour',
    last_engine_hour_adjustment: 'Last Engine Hour Adjustment',
    please_note_that_any_adjustment_will_calculated_when_its_synced_engine_hour_is_available: "* Please note that any adjustment will calculated when it's synced engine hour is available",
    'set_adjust_to_engine_hour_to_-1_for_remove_the_adjustment': '* Set adjust to engine hour to -1 for remove the adjustment',
    pto_critical_alert: 'PTO Critical Alert',
    pto_2_critical_alert: 'PTO 2 Critical Alert',
    pto_display: 'PTO Display',
    pto_door_sensor: 'PTO Door Sensor',
    alert_triggered: 'Alert Triggered',
    when_pto_is_on: 'When PTO is ON',
    when_pto_is_off: 'When PTO is OFF',
    never_trigger: 'Never Trigger',
    upload_profile_image: 'Upload Profile Image',
    confirm_upload: 'Confirm Upload',
    remove_selected_image: 'Remove Selected Image',
    billing_entity_name: 'Billing Entity Name',
    billing_entity: 'Billing Entity',
    vehicle_document: 'Vehicle Document',
    voltage: 'Voltage',
    power_status: 'Power Status',
    power_status_off: 'Off',
    power_status_normal: 'Normal',
    power_status_abnormal: 'Abnormal',
    power_status_error: 'Error',
    power_status_weak: 'Weak',
    power_status_healthy: 'Healthy',
    power_status_aware: 'Aware',
    
    
    create_vehicle: 'Create Vehicle',
    update_vehicle: 'Update Vehicle',
    vehicle_updated_successfully: 'Updated successfully',
    delete_vehicle: 'Delete Vehicle',
    delete_tracker: 'Delete Tracker',
    IDLING: 'Idling',
    DRIVING: 'Driving',
    PARKING: 'Parking',
    OFFLINE: 'Offline',
    battery: 'Battery',
    battery_percentage: 'Battery Percentage',
    satellite: 'Satellite',
    antenna: 'Antenna',
    odometer: 'Odometer',
    fuel_details: 'Fuel Details',
    device_model: 'Device Model',
    terminal_id: 'Terminal ID',
    timezone: 'Timezone',
    fuel_enable: 'Fuel Enable',
    device_mode: 'Device Mode',
    rotation_sensor_setting: 'Rotation Sensor Setting',
    rotation_sensor: 'Rotation Sensor',
    temperature_sensor_setting: 'Temperature Sensor Setting',
    temperature_sensor: 'Temperature Sensor',
    fuel_sensor_setting: 'Fuel Sensor Setting',
    fuel_sensor: 'Fuel Sensor',
    minimum_refuel_detection: 'Minimum Refuel Detection',
    minimum_tank_lvl_oil_resistance: 'Minimum Tank Level (%) / Oil Resistance (ohm)',
    maximum_tank_lvl_oil_resistance: 'Maximum Tank Level (%) / Oil Resistance (ohm)',
    fuel_tap_sensor: 'Fuel Tap Sensor',
    reverse_ohm: 'Reverse (ohm)',
    sensor_type: 'Sensor Type',
    tank_volume: 'Tank Volume',
    general: 'General',
    reverse: 'Reverse',
    create_tracker: 'Create Tracker',
    update_tracker: 'Update Tracker',
    please_enter_sim_card_no: 'Please enter sim card no',
    please_select_device_mode: 'Please select device mode',
    please_enter_device_id: 'Please enter device id',
    please_select_device_type: 'Please select device type',
    please_select_protocol_type: 'Please select protocol type',
    medical_expiry_date: 'Medical Expiry Date',
    create_driver: 'Create Driver',
    update_driver: 'Update Driver',
    resigned: 'Resigned',
    suspended: 'Suspended',
    employed: 'Employed',
    please_enter_driver_name: 'Please Enter Driver Name',
    please_select_employment_status: 'Please Select Employment Status',
    delete_driver: 'Delete Driver',
    vehicle_status: 'Vehicle Status',
    update_vehicle_status: 'Update Vehicle Status',
    generating_certificate: 'Generating Certificate',
    please_wait_while_we_download_your_file_this_may_take_awhile_thanks: 'Please wait while we download your file this may take a while, thanks',
    map_instance: 'Map Instance',
    map_not_ready_yet: 'Map is not ready yet',
    owner: 'Owner',
    only_shown_account_enable: 'Only Shown Account Enable',
    user: 'User',
    integration_list: 'Integration List',
    online_status: 'Online Status',
    offline_duration: 'Offline Duration',
    peripheral_offline_duration: 'Peripheral Offline Duration',
    movement_status: 'Movement Status',
    please_enter_map_instance_name: 'Please Enter Map Instance Name',
    please_select_integration_type: 'Please Select Integration Type',
    please_select_owner: 'Please Select Owner',
    please_select_only_shown_account_enable: 'Please Select Only Shown Account Enable',
    please_select_integration_list: 'Please Select Integration List',
    profile: 'Profile',
    device_settings: 'Device Settings',
    user_settings: 'User Settings',
    manage_temporary_view: 'Manage Temporary View',
    company_rules_complaints: 'Company Rules & Complaints',
    help_center: 'Help Center',
    contact_us: 'Contact Us',
    contact_us_banner_title: "We're here to help you.",
    contact_us_banner_subtitle: 'We want to hear from you',
    need_our_help: 'Need our help?',
    email_address: 'Email Address',
    your_issue: 'Your Issue',
    please_enter_your_issue: 'Please Enter Your Issue',
    please_complete_recaptcha: 'Please complete the reCAPTCHA verification',
    contact_us_submitted_successfully: 'Thank you for contacting us. We sincerely appreciate your feedback and will respond to you as soon as possible.',
    edit_password: 'Edit Password',
    update_password_successfully: 'Update Password Successfully',
    company_logo: 'Company Logo',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    please_enter_current_password: 'Please Enter Current Password',
    please_enter_new_password: 'Please Enter New Password',
    please_enter_confirm_password: 'Please Enter Confirm Password',
    password_not_match: 'Password Not Match',
    faqs: 'FAQs',
    frequently_asked_questions: 'Frequently Asked Questions',
    keyword: 'Keyword',
    focus_on: 'Focus On',
    driving_duration: 'Driving Duration',
    create_map_instance: 'Create Map Instance',
    update_map_instance: 'Update Map Instance',
    delete_map_instance: 'Delete Map Instance',
    focus_vehicle: 'Focus Vehicle',
    driving: 'Driving',
    fill_color: 'Fill Color',
    stroke_color: 'Stroke Color',
    delete_geofence: 'Delete Geofence',
    create_geofence: 'Create Geofence',
    update_geofence: 'Update Geofence',
    new_map_instance: 'New Map Instance',
    create_poi: 'Create POI',
    update_poi: 'Update POI',
    delete_poi: 'Delete POI',
    create_checkpoint: 'Create Checkpoint',
    update_checkpoint: 'Update Checkpoint',
    delete_checkpoint: 'Delete Checkpoint',
    meter: 'Meter',
    please_enter_poi_name: 'Please Enter POI Name',
    please_enter_poi_latitude: 'Please Enter POI Latitude',
    please_enter_poi_longitude: 'Please Enter POI Longitude',
    please_select_poi_icon: 'Please Select POI Icon',
    please_enter_poi_radius: 'Please Enter POI Radius',
    please_enter_checkpoint_name: 'Please Enter Checkpoint Name',
    please_enter_checkpoint_latitude: 'Please Enter Checkpoint Latitude',
    please_enter_checkpoint_longitude: 'Please Enter Checkpoint Longitude',
    please_enter_checkpoint_radius: 'Please Enter Checkpoint Radius',
    please_choose_checkpoint_type: 'Please Choose a Checkpoint Type',
    firmware_management: 'Firmware Management',
    geofence_settings: 'Geofence Settings',
    alarm_configuration_vehicle_control: 'Alarm Configuration / Vehicle Control',
    please_select_vehicle_to_set_alert_configurations_controls: 'Please Select Vehicle(s) to Set Alert Configurations / Controls',
    enter_keyword_to_search: 'Enter Keyword to Search',
    device_settings_mode: 'Device Settings Mode',
    upload_firmware: 'Upload Firmware',
    file_name: 'File Name',
    firmware_upload: 'Firmware Upload',
    click_here_to_upload_or_drop_your_files_here: 'Click here to upload or drop your files here',
    file: 'File',
    please_upload_firmware_file: 'Please Upload Firmware File',
    create_device_firmware: 'Create Device Firmware',
    update_device_firmware: 'Update Device Firmware',
    proceed: 'Proceed',
    fleet_list: 'Fleet List',
    selected_fleet: 'Selected Fleet',
    deselect: 'Deselect',
    select: 'Select',
    vehicle_list: 'Vehicle List',
    hint: 'Hint',
    device_firmware: 'Device Firmware',
    send: 'Send',
    please_select_device_firmware: 'Please Select Device Firmware',
    is_required: 'Is Required',
    wrong_format: 'Wrong Format',
    must_be_a_number: 'Must be a number',
    immobilizer_password: 'Immobilizer Password',
    please_enter_immobilizer_password: 'Please Enter Immobilizer Password',
    alarm_configuration_vehicle_control_history: 'Alarm Configuration / Vehicle Control History',
    alarm_configuration_vehicle_control_records: 'Alarm Configuration / Vehicle Control Records',
    cancelled: 'Cancelled',
    sent: 'Sent',
    settings_information: 'Settings Information',
    settings: 'Settings',
    value: 'Value',
    return_raw: 'Return Raw',
    return_value: 'Return Value',
    resend: 'Resend',
    refresh: 'Refresh',
    cancel_all_command: 'Cancel All Command',
    resend_all_command: 'Resend All Command',
    account_type: 'Account Type',
    new_user: 'New User',
    user_details: 'User Details',
    system_setting: 'System Setting',
    email_reporting_extra_modules: 'Email Reporting / Extra Modules',
    fleet_group_listing: 'Fleet Group Listing',
    weeklyOverspeedMailEnable: 'Weekly Overspeed Mail Enable',
    weeklySummaryMailEnable: 'Weekly Summary Mail Enable',
    dailySummaryMailEnable: 'Daily Summary Mail Enable',
    dailyMaintenanceMailEnable: 'Daily Maintenance Mail Enable',
    monthlyVehicleMileageMailEnable: 'Monthly Vehicle Mileage Mail Enable',
    admin: 'Admin',
    main_account: 'Main Account',
    sub_account: 'Sub Account',
    notification_email: 'Notification Email',
    notification_telephone_no: 'Notification Telephone No',
    add_notification_email: 'Add Notification Email',
    add_notification_telephone_no: 'Add Notification Telephone No',
    recipients: 'Recipients',
    alert_types: 'Alert Types',
    critical_notifications: 'Critical Notifications',
    ai_notifications: 'AI Notifications',
    tracking_page_data_interval_in_second: 'Tracking Page Data Interval In Second',
    idling_video_streaming_limit_minutes: 'Idling Video Streaming Duration',
    idling_video_streaming_limit_minutes_default: '5 Minutes (Default)',
    suggested_value: 'Suggested Value',
    currency_display: 'Currency Display',
    initial_map_location: 'Initial Map Location',
    critical_alert_filter: 'Critical Alert Filter',
    select_fleet_group: 'Select Fleet Group',
    no_fleet_group: 'No Fleet Group',
    selected_fleet_group: 'Selected Fleet Group',
    new_fleet_group: 'New Fleet Group',
    new_company: 'New Company',
    company_name: 'Company Name',
    company_registration_no: 'Company Registration No',
    company_contact_person: 'Company Contact Person',
    company_contact_no: 'Company Contact No',
    company_details: 'Company Details',
    company_address: 'Company Address',
    user_listing: 'User Listing',
    select_user: 'Select User',
    selected_user: 'Selected User',
    no_user: 'No User',
    detail: 'Detail',
    role: 'Role',
    new_role: 'New Role',
    roles_details: 'Roles Details',
    role_name: 'Role Name',
    features_enabled: 'Features Enabled',
    modules: 'Modules',
    features: 'Features',
    get: 'Get',
    update: 'Update',
    create: 'Create',
    refuse_all: 'Refuse All',
    grant_all: 'Grant All',
    select_module_first: 'Select Module First',
    new_setting: 'New Setting',
    setting_name: 'Setting Name',
    using_users_fleet: 'Using Users Fleet',
    email_notification_setting_details: 'Email Notification Setting Details',
    notification_setting_details: 'Notification Setting Details',
    create_new_notification_setting: 'Create New Notification Setting',
    notify_email_entry: 'Notify Email Entry',
    notify_entry: 'Notify Entry',
    switch_notification_method: 'Switch Notification Method',
    geofence_instance_filter: 'Geofence Instance Filter',
    notification_enabled: 'Notification Enabled',
    nearby: 'Nearby',
    checklist_profile: 'Checklist Profile',
    total_fuel_spend: 'Total Fuel Spend',
    total_distance: 'Total Distance',
    score: 'Score',
    copy_vehicle_info: 'Copy vehicle info to clipboard successfully',
    shortcuts: 'Shortcuts',
    starred_your_favourites_to_quick_access: 'Starred your favourites to quick access',
    roadtax_attachment: 'Roadtax Attachment',
    permit_attachment: 'Permit Attachment',
    notifications: 'Notifications',
    view_all_notifications: 'View All Notifications',
    critical_alert: 'Critical Alert',
    notification: 'Notification',
    driving_behaviour: 'Driving Behaviour',
    grid_of: 'Grid of {column}',
    columns: 'Columns',
    spotlight: 'Spotlight',
    no_data_available: 'No Data Available',
    no_notification: 'No Notification',
    please_select_fleet_group_or_vehicle_first: 'Please select fleet group or vehicle first',
    enter_plate_no: 'Enter Plate No',
    select_type: 'Select Type',
    please_complete_all_required_fields: 'Please Complete All Required Fields',
    please_enter_email: 'Please Enter Email',
    please_select_account_type: 'Please Select Account Type',
    please_select_status: 'Please Select Status',
    template_name: 'Template Name',
    company_checklist: 'Company Checklist',
    checklist: 'Checklist',
    please_select_checklist: 'Please Select Checklist',
    please_enter_company_name: 'Please Enter Company Name',
    new_checklist: 'New Checklist',
    checklist_details: 'Checklist Details',
    select_a_company: 'Select a Company',
    checklist_name: 'Checklist Name',
    checklist_item_name: 'Checklist Item Name',
    enable_remark: 'Enable Remark',
    enable_attachment: 'Enable Attachment',
    add_new_checklist_item: 'Add New Checklist Item',
    checklist_items: 'Checklist Items',
    select_a_workshop: 'Select a Workshop',
    rating_date: 'Rating Date',
    workshop_name: 'Workshop Name',
    select_a_status: 'Select a Status',
    please_enter_city: 'Please Enter City',
    please_enter_contact_no: 'Please Enter Contact No',
    new_breakdown_support: 'New Breakdown Support',
    city: 'City',
    contact_person: 'Contact Person',
    latitude: 'Latitude',
    longitude: 'Longitude',
    pos_code: 'Pos Code',
    speciality: 'Speciality',
    breakdown: 'Breakdown',
    smart_fleet_analytics_dashboard: 'Smart Fleet Analytics Dashboard',
    revenue_analysis_report: 'Revenue Analysis Report',
    total_expenses: 'Total Expenses',
    total_earning: 'Total Earning',
    current_total_earning: 'Current Total Earning',
    cost_trend_report: 'Cost Trend Report',
    total_trip_cost: 'Total Trip Cost',
    total_maintenance_cost: 'Total Maintenance Cost',
    average_monthly_cost: 'Average Monthly Cost',
    trip_cost: 'Trip Cost',
    maintenance_cost: 'Maintenance Cost',
    trip_cost_breakdown: 'Trip Cost Breakdown',
    fuel_purchased: 'Fuel Purchased',
    toll_cost: 'Toll Cost',
    driver_expense: 'Driver Expense',
    add_report_to_starred_success: 'Add report to starred success',
    remove_report_from_starred_success: 'Remove report from starred success',
    remove_shortcut_success: 'Remove shortcut success',
    add_shortcut_success: 'Add shortcut success',
    maintenance_cost_breakdown: 'Maintenance Cost Breakdown',
    expense: 'Expense',
    earning: 'Earning',
    top5_high_maintenance_cost: 'Top 5 High Maintenance Cost',
    fuel_performance_trend_report_for_industry_profile: 'Fuel Performance Trend Report for Industry Profile',
    operation_performance: 'Operation Performance',
    total_fuel_cost: 'Total Fuel Cost',
    est_idling_cost: 'Est Idling Cost',
    industry_profile_efficiency_target: 'Industry Profile Efficiency Target',
    industry_profile_efficiency_baseline: 'Industry Profile Efficiency Baseline',
    fuel_consumption_auto_refuel: 'Fuel Consumption (Auto Refuel)',
    fuel_purchase_refuel: 'Fuel Purchase (Refuel)',
    utilization_rate: 'Utilization Rate',
    fuel_performance: 'Fuel Performance',
    revenue_rm: 'Revenue (RM)',
    operational_performance_rm_km: 'Operational Performance (RM/km)',
    average_per_vehicle: 'Average Per Vehicle',
    this_month: 'This Month',
    target: 'Target',
    total_cost_breakdown: 'Total Cost Breakdown',
    top5_maintenance_breakdown: 'Top 5 Maintenance Breakdown',
    fuel_liter: 'Fuel (Liter)',
    total_vehicles: 'Total Vehicles',
    today_active: 'Today Active',
    today_inactive: 'Today Inactive',
    average_driver_score_speed: 'Average Driver Score & Speed',
    speed_km_h: 'Speed (km/h)',
    average_idling_rate_per_total_driving_time: 'Average Idling Rate Per Total Driving Time',
    average_speeding_rate_per_total_driving_time: 'Average Speeding Rate Per Total Driving Time',
    average_harsh_event_per_total_driving_time: 'Average Harsh Event Per Total Driving Time',
    top5_high_idling_event: 'Top 5 High Idling Event',
    top5_high_speeding_event: 'Top 5 High Speeding Event',
    top5_high_harsh_event: 'Top 5 High Harsh Event',
    fleet_idling_rate_trend: 'Fleet Idling Rate Trend',
    fleet_speeding_rate_trend: 'Fleet Speeding Rate Trend',
    fleet_harsh_event_trend: 'Fleet Harsh Event Trend',
    idling_of_total_drive_time_percentage: 'Idling Of Total Drive Time Percentage',
    speeding_of_total_drive_time_percentage: 'Speeding Of Total Drive Time Percentage',
    harsh_event_per_1000_km: 'Harsh Event Per 1000 km',
    score_distribution: 'Score Distribution',
    poor: 'Poor',
    meet_goals: 'Meet Goals',
    top_performance: 'Top Performance',
    risk_factors_speeding: 'Risk Factors - Speeding',
    tag: 'TAG',
    count: 'COUNT',
    rate_or_percentage: 'RATE or %',
    score_impact: 'SCORE IMPACT',
    driver_count: 'Driver Count',
    vehicle_history: 'Vehicle History',
    fuel_setting_history: 'Fuel Setting History',
    new_record: 'New Record',
    vehicle_record: 'Vehicle Record',
    efficient_date: 'Efficient Date',
    delete_vehicle_record: 'Delete Vehicle Record',
    delete_fuel_setting_record: 'Delete Fuel Setting Record',
    fuel_setting_record: 'Fuel Setting Record',
    vehicle_setting: 'Vehicle Setting',
    request_ip: 'Request IP',
    request_url: 'Request URL',
    enter_keyword: 'Enter Keyword',
    please_enter_keyword: 'Please Enter Keyword',
    please_select_mode: 'Please Select Mode',
    please_select_object_type: 'Please Select Object Type',
    please_select_user: 'Please Select User',
    insert: 'Insert',
    tollName: 'Toll Name',
    groupName: 'Group Name',
    tollGroupName: 'Toll Group Name',
    rateType: 'Rate Type',
    new_toll: 'New Toll',
    toll_point_panels: 'Toll Point Panels',
    create_a_toll_line: 'Create a toll line',
    There_is_no_toll_line: 'There has no any toll line yet',
    enter_name: 'Enter Name',
    select_point_type: 'Select Point Type',
    entry: 'Entry',
    exit: 'Exit',
    toll_list: 'Toll List',
    selected_toll_list: 'Selected Toll List',
    edit_toll_list: 'Edit Toll List',
    add_list: 'Add',
    remove_list: 'Remove',
    enter_group_name: 'Enter Group Name',
    group_name_is_required: 'Group Name is Required',
    tolls: 'Tolls',
    single: 'Single',
    multi: 'Multi',
    price_monthly: 'Price (monthly)',
    go_to_market_place: 'Go To Market Place',
    insurance_details: 'Insurance Details',
    price: 'Price',
    claim: 'Claim',
    claim_history: 'Claim History',
    renew: 'Renew',
    select_a_driver: 'Select a Driver',
    severity: 'Severity',
    avg_exceed: 'AVG Exceeded',
    avg_speed_limit: 'AVG. Speed/speed limit',
    time_and_location: 'Time & Location',
    select_a_route: 'Select a Route',
    new_route: 'New Route',
    new_route_group: 'New Route Group',
    route: 'Route',
    route_type: 'Route Type',
    route_details: 'Route Details',
    select_group_name: 'Select Group Name',
    select_a_route_type: 'Select a route type',
    select_a_route_group: 'Select a route group',
    select_a_code: 'Select a code',
    type_route_name_here: 'Type route name here',
    type_route_code_here: 'Type route code here',
    submit: 'Submit',
    map_details: 'Map Details',
    assign_by_operator: 'Assign By Operator',
    route_group_details: 'Route Group Details',
    shift_details: 'Shift Details',
    add_shift: 'Add Shift',
    shift_code: 'Shift Code',
    shift: 'Shift',
    assign: 'Assign',
    current_route_group: 'Current Route Group',
    job_type: 'Job Type',
    phone: 'Phone',
    pic: 'PIC',
    sequence: 'Sequence',
    edit_route: 'Edit Route',
    lite_access: 'Lite Access',
    operation_hour_date: 'Operation Hour Date',
    operation_hour_affordable_hour: 'Operation Hour Affordable Hour',
    operation_hour_remaining_hour: 'Operation Hour Remaining Hour',
    operation_hour_remaining_hour_status: 'Operation Hour Remaining Hour Status',
    fire_extinguisher_reminder_day: 'Fire Extinguisher Reminder Day',
    total_mileage_of_month: 'Total Mileage of Month',
    total_mileage_per_day: 'Total Mileage per Day',
    engine_date: 'Engine Date',
    engine_expiry_date: 'Engine Expiry Date',
    engine_affordable_mileage: 'Engine Affordable Mileage',
    engine_current_mileage: 'Engine Current Mileage',
    engine_remaining_mileage: 'Engine Remaining Mileage',
    engine_remaining_mileage_status: 'Engine Remaining Mileage Status',
    operation_hour_renew: 'Operation Hour Renew',
    last_operation_start_date: 'Last Operation Start Date',
    other_maintenance_affordable_engine_hours: 'Other Maintenance Affordable Engine Hours',
    fire_extinguisher_renew: 'Fire Extinguisher Renew',
    reminder_day: 'Reminder Day',
    engine_renew: 'Engine Renew',
    next_engine_maintenance_due_date: 'Next Engine Maintenance Due Date',
    current_mileage_maintenance_mileage_km: 'Current Mileage Maintenance Mileage (km)',
    engine_maitenance_affordable_mileage_km: 'Engine Maitenance Affordable Mileage (km)',
    delete_role: 'Delete Role',
    system_predefined: 'System Predefined',
    enable: 'Enable',
    other_1_title: 'Other 1 Document Type',
    other_1_type: 'Other 1 Type',
    other_2_title: 'Other 2 Document Type',
    other_2_type: 'Other 2 Type',
    other_3_title: 'Other 3 Document Type',
    other_3_type: 'Other 3 Type',
    other_4_title: 'Other 4 Document Type',
    other_4_type: 'Other 4 Type',
    affordable_hour: 'Affordable Hour',
    create_role: 'Create Role',
    update_role: 'Update Role',
    new_package: 'New Package',
    delete_package: 'Delete Package',
    create_package: 'Create Package',
    update_package: 'Update Package',
    package: 'Package',
    package_name: 'Package Name',
    package_details: 'Package Details',
    default_enable: 'Default Enable',
    expiry: 'Expiry',
    permit_reminder_day: 'Permit Reminder Day',
    roadtax_reminder_day: 'Roadtax Reminder Day',
    sgp_roadtax_reminder_day: 'SGP Roadtax Reminder Day',
    puspakom_reminder_day: 'Puspakom Reminder Day',
    service_reminder_day: 'Service Reminder Day',
    sgp_roadtax_attachment: 'SGP Roadtax Attachment',
    puspakom_attachment: 'Puspakom Attachment',
    service_attachment: 'Service Attachment',
    service_affordable_mileage: 'Service Affordable Mileage',
    service_current_mileage: 'Service Current Mileage',
    service_remaining_mileage: 'Service Remaining Mileage',
    sgp_roadtax_no: 'SGP Roadtax No',
    insurance_reserved_cost: 'Insurance Reserved Cost',
    insurance_reminder_day: 'Insurance Reminder Day',
    insurance_attachment: 'Insurance Attachment',
    update_documentation: 'Update Documentation',
    delete_attachment: 'Delete Attachment',
    file_size_exceeds_limit: 'File size exceeds limit (5mb)',
    please_select_billing_entity: 'Please select billing entity',
    please_enter_plate_no: 'Please enter plate no',
    energy_source: 'Energy Source',
    petrol: 'Petrol',
    diesel: 'Diesel',
    electric: 'Electric',
    new_trailer: 'New Trailer',
    pma_reminder_day: 'PMA Reminder Day',
    pma_attachment: 'PMA Attachment',
    delete_trailer: 'Delete Trailer',
    trailer_icon: 'Trailer Icon',
    prime_mover_vehicle_id: 'Prime Mover Vehicle ID',
    gps_tracker_integration: 'GPS Tracker Integration',
    create_trailer: 'Create Trailer',
    update_trailer: 'Update Trailer',
    notification_settings: 'Notification Settings',
    fleet_group_settings: 'Fleet Group Settings',
    first_name: 'First Name',
    last_name: 'Last Name',
    super_administrator: 'Super Administrator',
    support: 'Support',
    partnership: 'Partnership',
    personal_fleet: 'Personal Fleet',
    fleet_company: 'Fleet Company',
    merchant: 'Merchant',
    email_settings: 'Email Settings',
    fleet_settings: 'Fleet Settings',
    permission_settings: 'Permission Settings',
    control_password: 'Control Password',
    nickname: 'Nickname',
    main_user: 'Main User',
    create_user: 'Create User',
    update_user: 'Update User',
    delete_user: 'Delete User',
    trackvision_role: 'Trackvision Role',
    billing_entity_settings: 'Billing Entity Settings',
    package_settings: 'Package Settings',
    main_sub_account: 'Main/Sub Account',
    view_permit_history: 'View Permit History',
    view_roadtax_history: 'View RoadTax History',
    view_sgp_roadtax_history: 'View SGP RoadTax History',
    view_puspakom_history: 'View Puspakom History',
    view_service_history: 'View Service History',
    permit_history: 'Permit History',
    roadtax_history: 'RoadTax History',
    sgp_roadtax_history: 'SGP RoadTax History',
    puspakom_history: 'Puspakom History',
    service_history: 'Service History',
    document_no: 'Document No',
    delete_history: 'Delete History',
    other_history: 'Other History',
    view_other_history: 'View Other History',
    view_operation_hour_history: 'View Operation Hour History',
    operation_hour_history: 'Operation Hour History',
    view_fire_extinguisher_history: 'View Fire Extinguisher History',
    fire_extinguisher_history: 'Fire Extinguisher History',
    view_engine_history: 'View Engine History',
    engine_history: 'Engine History',
    prime_mover_vehicle: 'Prime Mover Vehicle',
    view_insurance_history: 'View Insurance History',
    insurance_history: 'Insurance History',
    view_pma_history: 'View PMA History',
    pma_history: 'PMA History',
    please_apply_filter_first: 'Please apply filter first',
    interval_minute: 'Interval (Minute)',
    source_mode: 'Source Mode',
    peripheral: 'Peripheral',
    new_lite_user: 'New Lite User',
    email_notification_update_report: 'Email Notification Report',
    hourly_vehicle_update: 'Hourly Vehicle Update',
    vehicle_visibility: 'Vehicle Visibility',
    day_available: 'Day Available',
    time_range: 'Time Range',
    select_vehicle_to_set_user_visibility: 'Select Vehicle To Set User Visibility',
    selected_vehicle_list: 'Selected Vehicle List',
    datetime: 'Date/Time',
    fuel_litre: 'Fuel Litre/%',
    temperature1: 'Temperature °C',
    temperature2: 'Temperature 2 °C',
    located: 'Located',
    not_located: 'Not Located',
    voltageV: 'Voltage (v)',
    latlng: 'Lat.Lng.',
    fixed: 'Fixed',
    none: 'None',
    left: 'Left',
    right: 'Right',
    select_a_template: 'Select a Template',
    rename_template: 'Rename Template',
    create_new_template: 'Create New Template',
    show_all_column: 'Show All Column',
    company_template: 'Company Template',
    editable: 'Editable',
    set_as_default: 'Set as Default',
    share_across_other: 'Share Across Other',
    field_chooser: 'Field Chooser',
    delete_template: 'Delete Template',
    create_template: 'Create Template',
    update_template: 'Update Template',
    please_enter_template_name: 'Please Enter Template Name',
    please_select_a_template_first: 'Please Select A Template First',
    view: 'View',
    single_date: 'Single Date',
    specific_date: 'Specific Date',
    confirm: 'Confirm',
    NA: 'N/A',
    command: 'Command',
    raw: 'Raw',
    antenna_status: 'Antenna Status',
    received_time: 'Received Time',
    layout: 'Layout',
    selected: 'Selected',
    select_a_alert_type: 'Select An Alert Type',
    type_of_maintenance_job: 'Type of Maintenance Job',
    odometer_mileage: 'Odometer Mileage (km)',
    new_service: 'New Service',
    due_soon: 'Due Soon',
    at_least_characters: 'At least {num} characters',
    new_maintenance_form: 'New Maintenance Form',
    planned: 'Planned',
    unplanned: 'Unplanned',
    print: 'Print',
    rating: 'Rating',
    rate_n_review: 'Rate & Review',
    contact_no2: 'Contact No.2',
    workshop_profile: 'Workshop Profile',
    status_changed: 'Status Changed',
    cancel_status_change: 'Cancel Status Change',
    ranger: 'Ranger',
    profile_image: 'Profile Image',
    allowance: 'Allowance',
    commission: 'Commission',
    charge_type: 'Charge Type',
    trip_date: 'Trip Date',
    new_training_record: 'New Training Record',
    new_violation_record: 'New Violation Record',
    new_trip_cost: 'New Trip Cost',
    summon: 'Summon',
    company_rule: 'Company Rule',
    complaint: 'Complaint',
    create_training_record: 'Create Training Record',
    update_training_record: 'Update Training Record',
    delete_training_record: 'Delete Training Record',
    delete_failed: 'Failed to Delete',
    create_trip_cost: 'Create Trip Cost',
    update_trip_cost: 'Update Trip Cost',
    delete_trip_cost: 'Delete Trip Cost',
    unexpected_error: 'An Unexpected Error Occurred',
    create_violation_record: 'Create Violation Record',
    update_violation_record: 'Update Violation Record',
    delete_violation_record: 'Delete Violation Record',
    invoice_no: 'Invoice No',
    excel_import: 'Excel Import',
    add_new_service_record: 'New Service Record',
    last_machinery_hour: 'Last Machinery Hour (hours)',
    item_code: 'Item Code',
    tax: 'Tax',
    new_category: 'New Category',
    add_log: 'Add Log',
    service_log_details: 'Service Log Details',
    attachments_upload_on_save: 'Attachments will be uploaded when you save the record.',
    attachment_upload_hint: 'Upload up to 10 files (PDF or image, max 15MB each).',
    choose_file: 'Choose File',
    attachment_file_size_exceeds_limit: 'File size exceeds limit (15MB)',
    max_attachments_exceeded: 'Maximum 10 attachments allowed',
    upload_failed: 'Upload failed',
    please_add_log: 'Please add a log here',
    enter: 'Enter',
    add_new_category: 'Add New Category',
    tracking: 'Tracking',
    enable_tracking_to_trace_expiry: 'Enable tracking to trace the expiry of the maintenance',
    edit_record: 'Edit Record',
    maintenance_profile: 'Maintenance Profile',
    vehicle_service_log_report: 'Vehicle Service Log Report',
    select_group: 'Select Group',
    select_category: 'Select Category',
    select_document_type: 'Select Document Type',
    select_device_type: 'Select Device Type',
    select_protocol_type: 'Select Protocol Type',
    please_select_energy_source: 'Please Select Energy Source',
    please_select_permanent: 'Please Select Permanent',
    net_total: 'Net Total',
    ledger_balance: 'Ledger Balance',
    ending_mileage: 'Ending Mileage',
    category_required: 'Category is required!',
    geofence_name: 'Geofence Name',
    create_lite_access: 'Create Lite Access',
    update_lite_access: 'Update Lite Access',
    used_for_immobilization_rfid_setup: '(Used for Immobilization, RFID Setup)',
    please_enter_role_name: 'Please Enter Role Name',
    please_enter_package_name: 'Please Enter Package Name',
    one_number_required: "One number letter required.",
    one_lowercase_required: "One lowercase letter required.",
    one_uppercase_required: "One uppercase letter required.",
    one_symbol_required: "One symbol required.",
    minimum_eight: "Minimum 8 characters.",
    please_enter_workshop_name: 'Please Enter Workshop Name',
    please_enter_contact_person: 'Please Enter Contact Person',
    please_enter_address: 'Please Enter Address',
    please_enter_latitude: 'Please Enter Latitude',
    please_enter_longitude: 'Please Enter Longitude',
    please_enter_latitude_and_longitude: 'Please Enter Latitude and Longitude',
    please_choose_type: 'Please Choose Type',
    please_enter_training_title: 'Please Enter Training Title',
    please_select_attended_date: 'Please Select Attended Date',
    please_select_violation_type: 'Please Select Violation Type',
    please_select_violation_date: 'Please Select Violation Date',
    please_enter_violation_description: 'Please Enter Violation Description',
    this_record: 'this record',
    please_select_charge_type: 'Please Select Charge Type',
    please_select_trip_date: 'Please Select Trip Date',
    excel_template: 'Excel Template',
    please_upload_with_the_download_xlsx_template_file: 'Please upload with the downloaded xlsx template file',
    drop_file_here: 'Drop File Here',
    or: 'Or',
    upload_error: 'Upload Error',
    import_fail_try_again: 'Import Failed, Please Try Again',
    please_download_template_and_use_this_template_for_upload: 'Please Download Template and Use it for Upload',
    download_template: 'Download Template',
    upload_file_template_to_import: 'Upload File Template To Import',
    service_record_imported: 'Service Record Imported',
    service_log_imported: 'Service Log Imported',
    total_fleet_maintenance_cost: 'Total Fleet Maintenance Cost',
    please_select_one_vehicle: 'Please Select One Vehicle',
    please_select_drive_in_datetime: 'Please Select Drive In DateTime',
    please_select_job_type: 'Please Select Job Type',
    create_maintenance_form: 'Create Maintenance Form',
    update_maintenance_form: 'Update Maintenance Form',
    delete_maintenance_form: 'Delete Maintenance Form',
    create_maintenance_service: 'Create Maintenance Service',
    update_maintenance_service: 'Update Maintenance Service',
    delete_service_record: 'Delete Service Record',
    update_on: 'Update On',
    this_year: 'This Year',
    last_year: 'Last Year',
    increase_to_previous_year: 'increase to previous year',
    reduce_to_previous_year: 'reduce to previous year',
    increase_to_previous_month: 'increase to previous month',
    reduce_to_previous_month: 'reduce to previous month',
    either_date_or_mileage_required: 'Either Date or Affordable Mileage is Required for Tracking',
    import_successful: 'Import Sucessful',
    close: 'Close',
    not_yet_setup: 'Not Yet Setup',
    uploading: 'Uploading...',
    please_wait: 'Please Wait',
    api_username: 'API Username',
    api: 'API',
    please_select_efficient_date: 'Please select efficient date',
    please_select_at_least_one_vehicle: 'Please select at least one vehicle',
    update_workshop_form: 'Update Workshop Form',
    create_workshop: 'Create Workshop',
    peripheral_name_is_required: 'Peripheral Name Is Required',
    select_a_peripheral_type: 'Select A Peripheral Type',
    select_an_api_integration: 'Select An API Integration',
    enter_device_id: 'Enter Device ID',
    peripheral_device_name: 'Peripheral Device Name',
    peripheral_type: 'Peripheral Type',
    api_integration: 'API Integration',
    tied_vehicle: 'Tied Vehicle',
    primary_peripheral: 'Primary',
    general_peripheral: 'General',
    peripheral_device: 'Peripheral Device',
    new_peripheral_device: 'New Peripheral Device',
    created_peripheral_device: 'Created Peripheral Device',
    updated_peripheral_device: 'Updated Peripheral Device',
    deleted_peripheral_device: 'Deleted Peripheral Device',
    delete_peripheral_device: 'Delete Peripheral Device',
    new_api_integration: 'New API Integration',
    add_peripheral_api: 'Add Peripheral API',
    edit_peripheral_api: 'Edit Peripheral API',
    api_name_is_required: 'API Name Is Required',
    select_an_api: 'Select An API',
    created_peripheral_api: 'Peripheral API Created',
    updated_peripheral_api: 'Peripheral API Updated',
    deleted_peripheral_api: 'Peripheral API Deleted',
    delete_peripheral_api: 'Delete Peripheral API',
    average_driver_safety_score: 'Average Driver Safety Score',
    average_vehicle_safety_score: 'Average Vehicle Safety Score',
    driver_safety_score_distribution: 'Driver Safety Score Distribution',
    vehicle_safety_score_distribution: 'Vehicle Safety Score Distribution',
    based_on_previous_day: 'Based On Previous Day',
    company_target_score_line: 'Company Target Score Line',
    company_score_baseline: 'Company Score Baseline',
    hos_compliance_score: 'HOS Compliance Score',
    driving_behaviour_score: 'Driving Behaviour Score',
    compared_to_previous_month: 'Compared To Previous Month',
    score_: 'Score(%)',
    total_safety_events: 'Total Safety Events',
    overspeeding: 'Overspeeding',
    harsh_braking: 'Harsh Braking',
    harsh_acceleration: 'Harsh Acceleration',
    harsh_cornering: 'Harsh Cornering',
    safety_event_distribution: 'Safety Event Distribution',
    safety_events_by_map: 'Safety Events by Map',
    safety_events_chart: 'Safety Events Chart',
    safety_event_number: 'Safety Event Number',
    ovs: 'OVS',
    ha: 'HA',
    hb: 'HB',
    hc: 'HC',
    vehicle_safety_analytics: 'Vehicle Safety Analytics',
    vehicle_performance_status: 'Vehicle Performance Status',
    top_5_scoring_vehicles: 'Top 5 Scoring Vehicles',
    bottom_5_low_scoring_vehicles: 'Bottom 5 Low Scoring Vehicles',
    score_distribution_driving_behaviour: 'Score Distribution (Driving Behaviour)',
    score_distribution_vehicle: 'Score Distribution (Vehicle)',
    top_5_overspeeding_vehicle: 'Top 5 Overspeeding Vehicles',
    top_5_harsh_acceleration_vehicle: 'Top 5 Harsh Acceleration Vehicles',
    top_5_harsh_braking_vehicle: 'Top 5 Harsh Braking Vehicles',
    top_5_harsh_cornering_vehicle: 'Top 5 Harsh Cornering Vehicles',
    top_5_scoring_driver: 'Top 5 Scoring Drivers',
    bottom_5_low_scoring_driver: 'Bottom 5 Low Scoring Drivers',
    top_5_overspeeding_driver: 'Top 5 Overspeeding Drivers',
    top_5_harsh_acceleration_driver: 'Top 5 Harsh Acceleration Drivers',
    top_5_harsh_braking_driver: 'Top 5 Harsh Braking Drivers',
    top_5_harsh_cornering_driver: 'Top 5 Harsh Cornering Drivers',
    top_5_mobile_usage_driver: 'Top 5 Mobile Usage Drivers',
    top_5_adas_bsm_driver: 'Top 5 ADAS/BSM Drivers',
    top_5_fatigue_driver: 'Top 5 Fatigue Drivers',
    top_5_closed_eye_driver: 'Top 5 Closed Eye Drivers',
    top_5_distracted_driving_driver: 'Top 5 Distracted Driving Drivers',
    safety_events_report: 'Safety Events Report',
    view_report: 'View Report',
    safety_event: 'Safety Event',
    vehicle_performance_report: 'Vehicle Performance Report',
    vehicle_safety_score: 'Vehicle Safety Score',
    performance_status: 'Performance Status',
    ai_safety_score: 'AI Safety Score',
    fleet_safety_analytics: 'Fleet Safety Analytics',
    total_event: 'Total Event',
    total_driver: 'Total Driver',
    driving_behaviour_event: 'Driving Behaviour Event',
    ai_safety_event: 'AI Safety Event',
    active_safety: 'Active Safety (ADAS)',
    blind_spot_monitoring: 'Blind Spot Monitoring (BSM)',
    driver_safety_monitoring: 'Driver Safety Monitoring (DSM)',
    ai_powered_vehicle_risk_level: 'AI-Powered Vehicle Risk Level',
    adas: 'ADAS',
    bsm: 'BSM',
    dsm: 'DSM',
    high_risk: 'High Risk',
    medium_risk: 'Medium Risk',
    low_risk: 'Low Risk',
    no_risk: 'No Risk',
    total_ai_safety_events: 'Total AI Safety Events',
    top_5_mobile_usage_vehicle: 'Top 5 Mobile Usage Vehicles',
    top_5_fatigue_vehicle: 'Top 5 Fatigue Vehicles',
    top_5_closed_eye_vehicle: 'Top 5 Closed Eye Vehicles',
    top_5_distracted_driving_vehicle: 'Top 5 Distracted Driving Vehicles',
    number_of_event: 'Number of Event',
    api_type: 'API Type',
    api_name: 'API Name',
    select_a_timezone: 'Select a Timezone',
    please_update_your_password: 'Please Update Your Password',
    review_status: 'Review Status',
    speed_range: 'Speed Range',
    video_view: 'Video View',
    mark_as_false_positive: 'Mark As False Positive',
    false_positive: 'False Positive',
    acknowledged: 'Acknowledged',
    acknowledge: 'Acknowledge',
    review_updated: 'Review Updated',
    cancel_acknowledge: 'Cancel Acknowledge',
    vehicle_performance_summary: 'Vehicle Performance Summary',
    vehicle_behaviour_score: 'Vehicle Behaviour Score',
    vehicle_performance_details: 'Vehicle Performance Details',
    count_of_violation: 'Count of Violation',
    hos_compliance: 'HOS Compliance',
    vehicle_behaviour: 'Vehicle Behaviour',
    ai_safety: 'AI Safety',
    event_details: 'Event Details',
    advance_only: 'Adv. Only',
    overview: 'Overview',
    driver_safety_score: 'Driver Safety Score',
    safety_event_detail: 'Safety Event Detail',
    watch_evidence: 'Watch Evidence',
    based_on: 'Based on',
    top_5_adas_bsm_vehicle: 'Top 5 ADAS/BSM Vehicle',
    score_distribution_ai_safety: 'Score Distribution (Ai Safety)',
    no_evidence: 'No Evidence',
    play_from_device: 'Play from Device',
    device_offline: 'Please wait device online to view evidence',
    peripheral_device_not_online: 'The Peripheral Device is not online, please wait device to online to preview the evidence',
    checking_evidence: 'Checking Evidence',
    speeding_range: 'Speeding Range',
    speeding_limit: 'Speeding Limit',
    company_settings: 'Company Settings',
    safety_target_score: 'Safety Target Score',
    safety_baseline_score: 'Safety Baseline Score',
    driver_safety_score_baseline: 'Driver Safety Score Baseline',
    hos_weight: 'HOS Weight',
    checklist_weight: 'Checklist Weight',
    summon_weight: 'Summon Weight',
    advanced_overspeed_weight: 'Advanced Overspeed Weight',
    advance_harsh_acceleration_weight: 'Advanced Harsh Acceleration Weight',
    advance_harsh_deceleration_weight: 'Advanced Harsh Deceleration Weight',
    advance_harsh_turning_weight: 'Advanced Harsh Turning Weight',
    sv_fatigue_weight: 'Fatigue Weight',
    sv_mobile_smoking_weight: 'Mobile/Smoking Weight',
    sv_distracted_driving_weight: 'Distracted Driving Weight',
    sv_adas_bsm_weight: 'ADAS/BSM Weight',
    aiSafety_adas_weight: 'AI Safety ADAS Weight',
    aiSafety_dsm_weight: 'AI Safety DSM Weight',
    aiSafety_bsm_weight: 'AI Safety BSM Weight',
    driving_behavour: 'Driving Behaviour',
    total_driving_violation_hour: 'Total Driving Violation Hour',
    total_work_violation_hour: 'Total Working Violation Hour',
    basic: 'Basic',
    advance: 'Advance',
    overspeed_weight: 'Overspeed Weight',
    harsh_acceleration_weight: 'Harsh Acceleration Weight',
    harsh_deceleration_weight: 'Harsh Deceleration Weight',
    harsh_turning_weight: 'Harsh Turning Weight',
    checklist_template_name: 'Checklist Template Name',
    default_checklist: 'Default Checklist',
    customized_checklist: 'Customized Checklist',
    e_signature: 'E-Signature',
    tick_all_items_section: 'Tick All Items Section',
    checklist_section: 'Checklist Section',
    add_template_item: 'Add Template Item',
    add_section: 'Add Section',
    add_section_to_start_customizing_your_checklist: 'Add Section to Start Customizing Your Checklist',
    customized_your_own_checklist_template: 'Customize Your Own Checklist Template',
    checklist_item: 'Checklist Item',
    add_checklist_item: 'Add Checklist Item',
    real_time_safety_alert: 'Real-Time Safety Alert',
    driving_behaviour_alert: 'Driving Behaviour Alert',
    notify_driver: 'Notify Driver',
    ai_safety_alert: 'AI Safety Alert',
    high_risk_to_low_risk: 'High Risk to Low Risk',
    low_risk_to_high_risk: 'Low Risk to High Risk',
    driver_safety_montoring: 'Driver Safety Monitoring (DSM)',
    blind_spot_montoring: 'Blind Spot Monitoring (BSM)',
    import_template: 'Import Template',
    new_checklist_template: 'New Checklist Template',
    are_you_sure_delete_this_record: 'Are you sure to delete this record?',
    driver_configuration_name: 'Driver Configuration Name',
    checklist_type: 'Checklist Type',
    checklist_template_settings: 'Checklist Template Settings',
    set_the_checklist_template_to_drivers: 'Set the Checklist Template to Drivers',
    checklist_template: 'Checklist Template',
    frequency: 'Frequency',
    reminder_notification: 'Reminder Notification',
    add_checklist_template: 'Add Checklist Template',
    checklist_group_configuration: 'Checklist Group Configuration',
    please_assign_driver_to_set_configuration: 'Please Assign Driver to Set Configuration',
    exceeded_rest_time_reminder_notification: 'Exceeded Rest Time Reminder Notification',
    module_reminder_settings: 'Module/Reminder Settings',
    exceeded_working_time_reminder_notification: 'Exceeded Working Time Reminder Notification',
    loading_discharge_module: 'Loading/Discharge Module',
    exceeded_loading_time_reminder_notification: 'Exceeded Loading Time Reminder Notification',
    exceeded_discharge_time_reminder_notification: 'Exceeded Discharge Time Reminder Notification',
    loading_discharge_waiting_module: 'Loading/Discharge Waiting Module',
    new_checklist_item: 'New Checklist Item',
    set_checklist_item_as: 'Set Checklist Item As',
    mandatory: 'Mandatory',
    english: 'English',
    malay: 'Malay',
    chinese: 'Chinese',
    indonesian: 'Indonesian',
    checklist_element: 'Checklist Element',
    check_mark_field: 'Check Mark Field',
    text_field: 'Text Field',
    numeric_field: 'Numeric Field',
    icon: 'Icon',
    attachment_and_remark: 'Attachment & Remark',
    preview_of_driver_care_checklist_items: 'Preview of Driver Care Checklist Items',
    other_languages: 'Other Languages',
    created_on: 'Created On',
    element: 'Element',
    new_driver_configuration: 'New Driver Configuration',
    day_required: 'Day is Required',
    frequency_required: 'Frequency is Required',
    checklist_template_required: 'Checklist Template is Required',
    driver_configuration_name_is_required: 'Driver Configuration Name is Required',
    validation: 'Validation',
    min_character_length: 'Minimum Character Length',
    max_character_length: 'Maximum Character Length',
    min_value: 'Minimum Value',
    max_value: 'Maximum Value',
    max_decimal_place: 'Maximum Decimal Place',
    system_default: 'System Default',
    daily: 'Daily',
    select_a_frequency_first: 'Select a Frequency First',
    driver_configuration_details: 'Driver Configuration Details',
    exceeded_rest_time_remainder_notification: 'Exceeded Rest Time Reminder Notification',
    last_updated_on: 'Last Updated On',
    reminder_notification_time: 'Reminder Notification Time',
    delete_driver_configuration: 'Delete Driver Configuration',
    update_driver_configuration: 'Update Driver Configuration',
    create_driver_configuration: 'Create Driver Configuration',
    new_supplier: 'New Supplier',
    create_supplier: 'Create Supplier',
    update_supplier: 'Update Supplier',
    delete_supplier: 'Delete Supplier',
    edit_checklist_item: 'Edit Checklist Item',
    new_item_code: 'New Item Code',
    create_item_code: 'Create Item Code',
    update_item_code: 'Update Item Code',
    delete_item_code: 'Delete Item Code',
    checklist_template_name_is_required: 'Checklist Template Name is Required',
    description_is_required: 'Description is Required',
    please_add_at_least_one_section: 'Please add at least one section.',
    please_select_an_item: 'Please Select an Item',
    enter_section_name: 'Enter Section Name',
    section_name_is_required: 'Section Name is Required',
    add_new: 'Add New',
    no_option: 'No Option',
    quantity: 'Quantity',
    subtotal: 'Subtotal',
    service_record_details: 'Service Record Details',
    unit_price: 'Unit Price',
    total_amount: 'Total Amount',
    driver_check_in_out_record: 'Driver Check In/Out Record',
    driver_status_monitor_board: 'Driver Status Monitor Board',
    status_time: 'Status Time',
    working_duration: 'Working Duration',
    resting_duration: 'Resting Duration',
    discharge_duration: 'Discharge Duration',
    loading_duration: 'Loading Duration',
    havent_checked_in_out: "Haven't Checked In/Out",
    all_pass: 'All Pass',
    failed: 'Failed',
    form_id: 'Form ID',
    approved: 'Approved',
    pending: 'Pending',
    form: 'Form',
    are_you_sure_you_want_to_approve_this_checklist: 'Are you sure you want to approve this checklist?',
    approval_confirmation: 'Approval Confirmation',
    '7_days': 'Last 7 days',
    custom: 'Custom',
    clone_template: 'Clone Template',
    checklist_completion: 'Checklist Completion',
    checklist_record: 'Checklist Record',
    checklist_creation_time: 'Checklist Creation Time',
    this_week: 'This Week',
    checklist_completion_list: 'Checklist Completion List',
    total_checklist: 'Total Checklist',
    delete_checklist_template: 'Delete Checklist Template',
    checklist_report: 'Checklist Report',
    condition: 'Condition',
    available: 'Available',
    unavailable: 'Unavailable',
    create_checklist_template: 'Create Checklist Template',
    update_checklist_template: 'Update Checklist Template',
    apad_print: 'APAD Print',
    checklist_approval_report: 'Checklist Approval Report',
    please_set_a_duration_for_the_link: 'Please set a duration for the link',
    activate_time: 'Activate Time',
    use_current_time: 'Use Current Time',
    show_speed: 'Show Speed',
    show_sensor_info: 'Show Sensor Info',
    create_link: 'Create Link',
    created_link: 'Created Link',
    done: 'Done',
    start_date_time: 'Start Date/Time',
    end_date_time: 'End Date/Time',
    manage_sharable_link: 'Manage Shareable Link',
    link_type: 'Link Type',
    deactivate_link: 'Deactivate Link',
    deactivated_link: 'Deactivated Link',
    delete_sharable_link: 'Delete Shareable Link',
    deleted_sharable_link: 'Deleted Shareable Link',
    link_copied_to_clipboard: 'Link copied to clipboard!',
    failed_to_copy_link: 'Failed to copy link.',
    no_link_found_to_copy: 'No link found to copy.',
    copy: 'Copy',
    stop_sharing: 'Stop Sharing',
    allow_sharing: 'Allow Sharing',
    create_sharable_link: 'Create Shareable Link',
    share: 'Share',
    generate_link: 'Generate Link',
    please_select_channels: '*Please select channels',
    cancel_share: 'Cancel Share',
    sharable_live_video: 'Shareable Live Video',
    eta: 'ETA',
    terminate_link: 'Terminate Link',
    permanent_removal_warning: 'Once terminate, this access will be permanently removed!',
    terminate: 'Terminate',
    sharable_link_tracking: 'Shareable Link Tracking',
    activated_link: 'Activated Link',
    active_link_to_allow_sharing: 'Active Link to Allow Sharing',
    sharable_link_generated: 'Shareable Link Generated',
    odometer_km: 'Odometer (KM)',
    bill_rm: 'Bill (RM)',
    bill_l: 'Bill (L)',
    bill_rate: 'Bill Rate (RM/L)',
    before_refuel_l: 'Before Refuel (L)',
    after_refuel: 'After Refuel (L)',
    auto_refuel: 'Auto Refuel',
    '+-_l': '+/- (L)',
    '+-_rm': '+/- (RM)',
    travel_distance_km: 'Travel Distance (KM)',
    accuracy: 'Accuracy (%)',
    import_refuel_records: 'Import Refuel Records',
    excel_file_upload: 'Excel File Upload',
    no_file: 'No File',
    refuel_record: 'Refuel Record',
    refuel_records: 'Refuel Records',
    upload_file_first: 'Please upload the file first',
    create_record: 'Create Record',
    import: 'Import',
    sync_from_fms: 'Sync from FMS',
    edit_table_data: 'Edit Table Data',
    gas_station: 'Gas Station',
    refuel_detail: 'Refuel Detail',
    fuel_price_rm: 'Fuel Price (RM)',
    fuel_rate_rm_l: 'Fuel Rate (RM/L)',
    fuel_amount_l: 'Fuel Amount (L)',
    please_fill_all_required_columns_before_using: 'Please fill all required columns before using',
    variation: 'Variation',
    check: 'Check',
    select_file: 'Select File',
    file_limit_is_1_selected: 'File Limit is 1. Selected:',
    files: 'Files.',
    delete_to_upload_new_file: 'Delete To Upload New File',
    cancel_the_transfer_of: 'Cancel the Transfer of',
    select_a_datetime: 'Select a Date/Time',
    key_in_a_location: 'Key in a Location',
    select_a_gas_station: 'Select a Gas Station',
    fuel_price_is_required: 'Fuel Price is required',
    fuel_rate_is_required: 'Fuel Rate is required',
    fuel_amount_is_required: 'Fuel Amount is required',
    delete_refuel_record: 'Delete Refuel Record',
    delete_system_auto_refuel_confirmation: 'Delete System Auto Refuel Confirmation',
    are_you_sure_delete_system_auto_refuel: 'Are you sure you want to delete this system auto refuel record?',
    delete_system_auto_refuel_success: 'System auto refuel record deleted successfully',
    create_refuel_record: 'Create Refuel Record',
    update_refuel_record: 'Update Refuel Record',
    page_will_close_in_seconds: 'This page will close in {seconds} seconds.',
    refuel_report_will_be_refreshed: 'The refuel report will be refreshed.',
    refuel_record_insertion_confirmation: 'Refuel Record Insertion Confirmation',
    are_you_sure_to_insert_bill: 'Are you sure you want to insert the bill?',
    bill_litre_insertion: 'Bill Litre Insertion',
    bill_litre_insertion_completed: 'Bill Litre Insertion Completed',
    insert_refuel_variation: 'Insert Refuel Variation',
    cancel_edit_or_insert_refuel_variation_to_continue: 'Please cancel edit or insert refuel variation to continue.',
    some_drivers_or_vehicles_are_not_valid_please_select_valid_input_before_submitting: 'Some drivers or vehicles are not valid. Please select valid input before submitting.',
    no_matched_or_selected_vehicle_for_refuel_import: 'There are no matched or selected vehicles for those refuel records, so no refuel records were imported into the system.',
    cancel_edit: 'Cancel Edit',
    data_not_in_system: '(Data Not In System)',
    refuel_record_insertion_completed: 'Refuel Record Insertion Completed',
    refuel_record_insertion: 'Refuel Record Insertion',
    total_usage_l: 'Total Usage (L)',
    total_refuel_l: 'Total Refuel (L)',
    statical_time: 'Statistical Time',
    litre_per_km: 'Litre per KM',
    average_fuel_consumption_km_l: 'Average Fuel Consumption (KM/L)',
    fuel_analysis_chart: 'Fuel Analysis Chart',
    speed_analysis_chart: 'Speed Analysis Chart',
    refuel_datetime: 'Refuel Date/Time',
    minute_s: 'Minute(s)',
    usage_l: 'Usage (L)',
    rm_km: 'RM/KM',
    km_liter: 'KM/Litre',
    l_km: 'Litre/KM',
    fuel_l: 'Fuel (L)',
    idling_usage_l: 'Idling Usage (L)',
    idling_cost_rm: 'Idling Cost (RM)',
    idling_time: 'Idling Time',
    total_journey_duration_hh_mm: 'Total Journey Duration (HH:MM)',
    journey_time: 'Journey Time',
    liter_km: 'Litre/KM',
    vehicle_fuel_analysis: 'Vehicle Fuel Analysis',
    total_liter_l: 'Total Liter (L)',
    auto_refuel_rm: 'Auto Refuel (RM)',
    auto_refuel_l: 'Auto Refuel (L)',
    accuracy_perc: 'Accuracy (%)',
    incl: 'INCL',
    excl: 'EXCL',
    mismatch: 'Mismatch',
    km_per_liter: 'KM per Liter',
    liter_per_100km: 'Liter per 100KM',
    miles_per_gallon: 'Miles per Gallon',
    mileage_liter_by_statement_report: 'Mileage/Litre by Statement Report',
    fuel_spend: 'Fuel Spend',
    mark_as_valid: 'Mark as Valid',
    mark_as_invalid: 'Mark as Invalid',
    refuel_details: 'Refuel Details',
    fuel_dropped: 'Fuel Dropped',
    fuel_dropped_details: 'Fuel Dropped Details',
    dropped_fuel_litre_l: 'Dropped Fuel Litre (L)',
    dropped_fuel_percentage_perc: 'Dropped Fuel Percentage (%)',
    validation_status: 'Validation Status',
    valid: 'Valid',
    invalid: 'Invalid',
    are_you_sure_you_want_to_mark_the_selected_rows_as_valid: 'Are you sure you want to mark the selected rows as valid?',
    are_you_sure_you_want_to_mark_the_selected_rows_as_invalid: 'Are you sure you want to mark the selected rows as invalid?',
    fuel_drop_marked: 'Fuel Drop Marked',
    mark_fuel_drop: 'Mark Fuel Drop?',
    checklist_log: 'Checklist Log',
    driver_configuration: 'Driver Configuration',
    please_select_a_driver: 'Please select a driver',
    please_select_date_range: 'Please select a date range',
    your_passord_has_not_been_updated_in_over: 'Your password has not been updated in over',
    please_update_it_to_keep_your_account_secure: 'Please update it to keep your account secure',
    at_least_one_row_is_required: 'At least one row is required',
    select_a_billing_entity: 'Select a billing entity',
    compare_to_last_7_days: 'Compare to Last 7 Days',
    operating_days: 'Operating Days',
    compare_to_last_30_days: 'Compare to Last 30 Days',
    compare_to_previous_period: 'Compare to Previous Period',
    total_violation_count: 'Total Violation Count',
    total_checklist_count: 'Total Checklist Count',
    vehicle_idling_time_list: 'Vehicle Idling Time List',
    vehicle_high_speed_list: 'Vehicle High Speed List',
    vehicle_high_fuel_consumption_list: 'Vehicle High Fuel Consumption List',
    vehicle_fuel_economy_list: 'Vehicle Fuel Economy List',
    safety_driver_list: 'Safety Driver List',
    high_risk_driver_list: 'High Risk Driver List',
    check_all: 'Check All',
    safevision_integrated: 'SafeVision Integrated',
    aircond: 'Aircond',
    end: 'End',
    start: 'Start',
    idle: 'Idle',
    selected_but_did_not_press_ok: 'You selected a time but didn’t press OK.',
    current_driver: 'Current Driver',
    assign_driver: 'Assign Driver',
    unassign_driver: 'Unassign Driver',
    assigned_driver: 'Assigned Driver',
    unassigned_driver: 'Unassigned Driver',
    unassign_driver_by_leaving_blank: 'Unassign Driver By Leaving Blank',
    icop_compliance_score: 'ICOP Compliance Score',
    icop_compliance: 'ICOP Compliance',
    checklist_compliance: 'Checklist Compliance',
    count_of_completion: 'Count of Completion',
    summons: 'Summons',
    driver_performance_summary: 'Driver Performance Summary',
    driver_performance_details: 'Driver Performance Details',
    accountType: {
        admin: 'Super Administrator',
        support: 'Support',
        partner: 'Partnership',
        customer: 'Personal Fleet',
        fleet: 'Fleet Company',
        merchant: 'Merchant'
    },
    safety_score: 'Safety Score',
    icop_violation: 'ICOP Violation',
    driver_safety: 'Driver Safety',
    vehicle_safety: 'Vehicle Safety',
    fuel_type: 'Fuel Type',
    total_distance_km: 'Total Distance (KM)',
    fuel_consumption_l: 'Fuel Consumption (L)',
    fuel_efficiency_l_km: 'Fuel Efficiency (L/KM)',
    co2_emission_rate_kg_km: 'CO₂ Emission Rate(KG/KM)',
    co2_emmission_rate_fuel_kg_l: 'CO₂ Emission Rate / Fuel (KG/L)',
    esg_detail_report: 'ESG Detail Report',
    esg_report: 'ESG Report',
    esg_monthly_report: 'ESG Monthly Report',
    esg: 'ESG',
    driver_safety_analytics: 'Driver Safety Analytics',
    driver_performance_status: 'Driver Performance Status',
    score_distribution_icop_compliance: 'Score Distribution (ICOP Compliance)',
    total_check_in_drivers: 'Total Check-In Drivers',
    complete: 'Complete',
    noComplete: "Didn't Complete",
    driver_performance_report: 'Driver Performance Report',
    completed_the_checklist: 'Completed the Checklist',
    number_of_driver_check_in: 'Number of Driver Check-In',
    esg_details: 'ESG Details',
    last_6_months: 'Last 6 Months',
    use_month_range: 'Month Range',
    use_date_range: 'Date Range',
    variation_checked: 'Variation Checked',
    please_ensure_there_is_datetime_vehicle_and_refuel_amount: 'Please ensure there is Date/Time, Vehicle, and Refuel Amount filled',
    vehicle_safety_events: 'Vehicle Safety Events',
    vehicle_safety_event_score: 'Vehicle Safety Event Score',
    driver_signature: 'Driver Signature',
    vehicle_usage: 'Vehicle Usage',
    vehicle_usage_record: 'Vehicle Usage Record',
    vehicle_usage_records: 'Vehicle Usage Record(s)',
    vehicle_summary: 'Vehicle Summary',
    journey_summary: 'Journey Summary',
    transit: 'Transit',
    total_fuel_consumed: 'Total Fuel Consumed',
    fuel_refuel: 'Fuel Refuel',
    duration_percent: 'Duration (%)',
    top_speed: 'Top Speed',
    fuel_wastage: 'Fuel Wastage',
    average_speed: 'Average Speed',
    create_new_user: 'Create New User',
    owner_settings: 'Owner Settings',
    create_billing_entity: 'Create Billing Entity',
    update_billing_entity: 'Update Billing Entity',
    delete_billing_entity: 'Delete Billing Entity',
    recover_engine_vehicle_control: 'Recover Engine Vehicle Control',
    stop_engine_vehicle_control: 'Stop Engine Vehicle Control',
    please_enter_immobilizer_password_to_proceed_the_action: 'Please enter immobilizer password to proceed the action',
    check_details: 'Check Details',
    stop_engine: 'Stop Engine',
    recover_engine: 'Recover Engine',
    vehicle_engine_stopping: 'Vehicle engine stop command is now executing.',
    vehicle_engine_recovering: 'Vehicle engine recover command is now executing.',
    something_went_wrong: 'Something went wrong',
    authenticate_using_a_code_generated_by_an_app_installed_on_your_mobile_device_or_computer_to_increase_the_security_of_your_application: 'Authenticate using a code generated by an app installed on your mobile device or computer to increase the security of your application.',
    a_virtual_2fa_device_is_an_application_running_on_your_device_that_you_can_configure_by_scanning_a_qr_code: 'A virtual 2FA device is an application running on your device that you can configure by scanning a QR code.',
    install_a_compatible_application_such_as_google_authenticator_duo_mobile_or_authy_app_on_your_mobile_device_or_computer: 'Install a compatible application such as Google Authenticator, Duo Mobile, or Authy app on your mobile device or computer.',
    this_account_has_enabled_two_factor_authentication_2fa: 'This account has enabled two-factor authentication (2FA).',
    this_account_has: 'This account has',
    enabled: 'enabled',
    two_factor_authentication_2fa: 'Two-Factor Authentication (2FA).',
    open_your_authenticator_app_scan_the_qr_code_or_enter_the_secret_key_manually: 'Open your authenticator app, scan the QR code or enter the secret key manually',
    show_secret_key: 'Show Secret Key',
    hide_secret_key: 'Hide Secret Key',
    two_factor_authentication: 'Two-Factor Authentication',
    two_factor_authentication_2fa_authenticator_app: 'Two-Factor Authentication (2FA) Authenticator App',
    disable: 'Disable',
    please_enter_your_password_to_proceed_with_2fa_disabling: 'Please enter your password to proceed with 2FA disabling',
    enter_your_password: 'Enter your password',
    authentication_code: 'Authentication Code',
    '2fa_disabled': '2FA Disabled',
    '2fa_data_generated_please_verify_2fa_to_enable': '2FA Data Generated. Please verify 2FA to enable',
    setup_now: 'Setup Now',
    please_enter_your_password_to_proceed_with_setup: 'Please enter your password to proceed with setup',
    set_up_two_factor_authentication_2fa: 'Set up Two-Factor Authentication (2FA)',
    type_2fa_codes_shown_from_authenticator_app_below: 'Type 2FA codes shown from authenticator app below',
    enable_now: 'Enable Now',
    '2fa_enabled': '2FA Enabled',
    your_account_is_protected_with: 'Your account is protected with',
    to_finish_signing_in_enter_the_code_from_your_authenticator_application_below: 'To finish signing in, enter the code from your authenticator application below',
    '2fa_code': '2FA Code',
    please_enter_valid_code: 'Please enter valid code',
    top_5_high_maintenance_cost: 'Top 5 High Maintenance Cost',
    video_preview: 'Video Preview',
    eventCategorySection: {
        advanceOverspeed: 'Overspeed',
        advanceHarshDeceleration: 'Harsh Deceleration',
        advanceHarshAcceleration: 'Harsh Acceleration',
        advanceHarshTurning: 'Harsh Turning',
        aiSafetyAdas: 'ADAS',
        aiSafetyDsm: 'DSM',
        aiSafetyBsm: 'BSM',
    },
    alert_records: 'Alert Records',
    ago: 'ago',
    reset_layout: 'Reset Layout',
    travelled_duration: 'Travelled Duration',
    travelled_distance_km: 'Travelled Distance (KM)',
    zone: 'Zone',
    alarm_type: 'Alarm Type',
    alarm_level: 'Alarm Level',
    geofence_filter: 'Geofence Filter',
    geofence_category: 'Geofence Category',
    geofence_category_management: 'Geofence Category Management',
    switch_to_create_mode: 'Switch to Create Mode',
    switch_to_edit_mode: 'Switch to Edit Mode',
    enable_password_expiring_mode: 'Enable Password Expiring Mode',
    reminder_only: 'Reminder Only',
    logout_after_expired: 'Logout After Expired',
    password_expiry_day: 'Password Expiry Day',
    disabled: 'Disabled',
    your_passord_will_expire_in: 'Your password will expire in',
    days_on: 'days, On',
    please: 'Please ',
    update_: 'update ',
    it_to_prevent_any_service_interruption: 'it to prevent any service interruption',
    it_to_keep_your_account_secure: 'it to keep your account secure',
    vehicle_drive_rest_report: 'Vehicle Drive Rest Report',
    rest_duration: 'Rest Duration',
    driver_rest_report: 'Driver Rest Report',
    total_driving_hour: 'Total Driving Hour',
    total_rest_hour: 'Total Rest Hour',
    driving_time: 'Driving Time',
    resting_time: 'Resting Time',
    duration_of_engine_on: 'Duration of Engine On',
    from_location: 'From Location',
    to_location: 'To Location',
    safety_alert_type: 'Safety Alert Type',
    safety_alert_level: 'Safety Alert Level',
    safety_alert_description: 'Safety Alert Description',
    export_historical_playback: 'Export Historical Playback',
    one_day_ago: 'One Day Ago',
    two_day_ago: 'Two Day Ago',
    three_day_ago: 'Three Day Ago',
    highToLow: 'High Risk to Low Risk',
    lowToHigh: 'Low Risk to High Risk',
    internal_combustion_engine_vehicles: 'Internal Combustion Engine Vehicles',
    temperature_2: 'Temperature 2',
    temperature_3: 'Temperature 3',
    temperature_4: 'Temperature 4',
    best_in_class_fuel_efficiency: 'Best in Class Fuel Efficiency',
    scope_overview: 'Scope Overview',
    tailpipe_emissions: 'Tailpipe Emissions',
    carbon_emission: 'Carbon Emission',
    fuel_cost_and_usage: 'Fuel Cost & Usage',
    potential_benchmark_savings: 'Potential Benchmark Savings',
    potential_best_in_class_savings: 'Potential Best in Class Savings',
    average_expenses: 'Average Expenses',
    fuel_cost: 'Fuel Cost',
    average_fuel_economy: 'Average Fuel Economy',
    average_benchmark_fuel_economy: 'Average Benchmark Fuel Economy',
    average_best_in_class_fuel_economy: 'Average Best in Class Fuel Economy',
    your_fleet: 'Your Fleet',
    benchmark: 'Benchmark',
    best_in_class: 'Best in Class',
    CO2_emission: 'CO2 Emission',
    average_ice_fuel_economy: 'Average ICE Fuel Economy',
    ton_metric_co2: 'Ton Metric CO2',
    vehicle_monthly_esg_performance_report: 'Vehicle Monthly ESG Performance Report',
    avg_speed_km_h: 'Average Speed (KM/H)',
    vehicle_journey_report: 'Vehicle Journey Report',
    current_temperature: 'Current Temperature',
    battery_health: 'Battery Health',
    engine_on_off: 'Engine On/Off',
    compressor_on_off: 'Compressor On/Off',
    cold_chain_analytics: 'Cold Chain Analytics',
    cold_chain_monitoring_dashboard: 'Cold Chain Monitoring Dashboard',
    front_compartment_alert: 'Front Compartment Alert',
    rear_compartment_alert: 'Rear Compartment Alert',
    critical_vehicle: 'Critical Vehicle',
    offline_vehicle: 'Offline Vehicle',
    real_time_temperature_monitoring: 'Real-Time Temperature Monitoring',
    front_temperature: 'Front Temperature',
    rear_temperature: 'Rear Temperature',
    temperature_1: 'Temperature 1',
    humidity_rh: 'Humidity (RH)',
    vpd_kpa: 'VPD (kPa)',
    first_trip: 'First Trip',
    current_location: 'Current Location',
    table_view: 'Table',
    card_view: 'Card',
    vpd: 'VPD',
    temperature_details: 'Temperature Details',
    real_time_compartment_temperature: 'Real-time Compartment Temperature',
    door_sensor_analytics: 'Door Sensor Analytics',
    door_open_count: 'Door Open Count',
    total_open_time: 'Total Open Time',
    door_activity_log: 'Door Activity Log',
    door_events_same_hour: 'multiple events in this hour',
    mold_risk: 'Mold Risk',
    mold_risk_level_very_high: 'Very High',
    mold_risk_level_high: 'High',
    mold_risk_level_moderate: 'Moderate',
    mold_risk_level_low: 'Low',
    mold_risk_level_very_low: 'Very Low',
    mold_risk_level_none: 'None',
    dew: 'Dew',
    temperature_configuration: 'Temperature Configuration',
    max_temperature_celcius: 'Max Temperature (°C)',
    min_temperature_celcius: 'Min Temperature (°C)',
    max_bold_risk_percentage: 'Max Bold Risk (%)',
    last_24_hours: 'Last 24 Hours',
    last_1_day: 'Last 1 Day',
    last_2_days: 'Last 2 Days',
    last_3_days: 'Last 3 Days',
    min_temperature: 'Min Temperature',
    max_temperature: 'Max Temperature',
    avg_vpd: 'Avg VPD',
    avg_mold_risk: 'Avg Mold Risk',
    critical_threshold: 'Critical Threshold',
    avg_dew: 'Avg Dew',
    times: 'times',
    secret_key: 'Secret Key',
    datetime_format_is_utc: 'Datetime format is UTC',
    once_closed_secret_cannot_be_reveal_anymore: 'Once closed, secret key cannot be reveal anymore',
    are_you_sure_to_close: 'Are you sure to close?',
    revoke: 'Revoke',
    revoke_api_key: 'Revoke API Key',
    are_you_sure_revoke: 'Are you sure to revoke?',
    once_revoked_cannot_be_revoked_again: 'Once revoked, cannot be revoked again',
    revoke_api_key_success: 'Revoke API Key Success',
    created_api_key: 'Created API Key',
    create_api_key: 'Create API Key',
    please_select_expiry_date: 'Please select expiry date',
    select_expiry_date_blank_for_no_expiry_date: 'Select expiry date (blank for no expiry date)',
    create_new_api_key: 'Create New API Key',
    once_deleted_cannot_be_restored: 'Once deleted, cannot be restored',
    delete_api_key: 'Delete API Key',
    delete_api_key_success: 'Delete API Key Success',
    api_description: 'API Description',
    updated_api_key: 'Updated API Key',
    update_api_key: 'Update API Key',
    update_api_key_success: 'Update API Key Success',
    created_new_api_key: 'Created New API Key',
    create_new_api_key_success: 'Create New API Key Success',
    revoked: 'Revoked',
    deleted_api_key: 'Deleted API Key',
    secure_secret_key: 'Please note that the secret key cannot be retrieved once this session ends, so be sure to store it securely.',
    api_documentation: 'API Documentation',
    temperature_report: 'Temperature Report',
    from_date_time: 'From Date Time',
    to_date_time: 'To Date Time',
    avg_temperature: 'Avg. Temperature',
    avg_temperature_2: 'Avg. Temperature 2',
    avg_temperature_3: 'Avg. Temperature 3',
    avg_temperature_4: 'Avg. Temperature 4',
    avg_humidity: 'Avg. Humidity',
    no_temperature_data: 'This Vehicle does not have temperature/humidity data or sensors enabled',
    temperature_log: 'Temperature Log',
    overspeed_report: 'Overspeed Report',
    overspeed_duration: 'Overspeed Duration',
    humidity: 'Humidity',
    pressure: 'Pressure',
    pressure_2: 'Pressure 2',
    cold_chain: 'Cold Chain',
    route_deviation_violation_report: 'Route Deviation Violation Report',
    route_deviation_instance: 'Route Deviation Instance',
    unauthorized_violation_count: 'Unauthorized Violation (Count)',
    unauthorized_stop_count: 'Unauthorized Stop (Count)',
    deviation_category: 'Deviation Category',
    select_a_date: 'Select a Date',
    file_time: 'File Time',
    download_center: 'Download Center',
    download_task: 'Download Task',
    download_task_already_exists: 'Download Task Already Exists',
    please_check_download_status_from: 'Please check download status from ',
    video_download_center: 'Video Download Center',
    download_started: 'Download Started',
    download_failed: 'Download Failed',
    request_failed: 'Request Failed',
    channel: 'Channel',
    warning: 'Warning',
    operations: 'Operations',
    file_size: 'File Size',
    task_start_time: 'Task Start Time',
    downloaded_time: 'Downloaded Time',
    download_local: 'Download Local',
    download_not_completed: 'Download Not Completed',
    redownload_task_begin: 'Redownload Task was begin',
    schedule_download: 'Schedule Download',
    schedule: 'Schedule',
    schedule_multiple_channel_video_download_task: 'Schedule Multiple Channel Video Download Task',
    multiple_channel_download: 'Multiple Channel Download',
    notify_email: 'Notify Email',
    audio_output: 'Audio Output',
    video_start_datetime: 'Video Start Datetime',
    video_end_datetime: 'Video End Datetime',
    please_enter_notify_email: 'Please enter notify email',
    please_select_audio_output: 'Please select audio output',
    please_select_at_least_one_channel: 'Please select at least one channel',
    schedule_download_success: 'Download task scheduled successfully',
    schedule_download_failed: 'Failed to schedule download task',
    replay_video: 'Replay Video',
    maximize: 'Maximize',
    restore: 'Restore',
    video_replay: 'Video Replay',
    evidence: 'Evidence',
    intercom_setting: 'Intercom Setting',
    select_one_intercom_type_to_communicate_with_the_driver: 'Select one intercom type to communicate with the driver',
    monitor: 'Monitor...',
    monitoring: 'Monitoring...',
    talkback: 'Talkback',
    talking: 'Talking...',
    stop: 'Stop',
    click_to_start_talking: 'Click to start talking',
    loading: 'Loading...',
    intercom: 'Intercom',
    idling_streaming_duration: 'Idling Streaming Duration',
    idling_streaming_remaining: 'Idling streaming time remaining',
    idling_streaming_limit_reached: 'Idling streaming duration limit reached',
    idling_streaming_reload_hint_before: 'Click',
    idling_streaming_reload_hint_after: 'to continue streaming live video',
    reload: 'Reload',
    click_to_start_monitoring: 'Click to start monitoring',
    invoice_date: 'Invoice Date',
    open: 'Open',
    in_progress: 'In Progress',
    closed: 'Closed',
    supplier_workshop: 'Supplier Workshop',
    confirmation: 'Confirmation',
    confirm_reopen_status: 'Change Closed Status? This will reopen the maintenance record and changes will be saved.',
    status_update: 'Status Update',
    fuel_calibration: 'Fuel Calibration',
    delete_fuel_calibration: 'Delete Fuel Calibration',
    update_fuel_calibration: 'Update Fuel Calibration',
    fuel_level_oil_resistance: 'Fuel Level (%) / Oil Resistance (ohm)',
    min_tank_level: 'Min Tank Level (%)',
    max_tank_level: 'Max Tank Level (%)',
    volume_l: 'Volume (L)',
    add_new_fuel_calibration: 'Add New Fuel Calibration',
    tank: 'Tank',
    tank_liter: 'Tank Litre',
    min_fuel_percentage: 'Min Fuel Percentage',
    max_fuel_percentage: 'Max Fuel Percentage',
    no_tracker_on_this_vehicle: 'No tracker on this vehicle',
    no_duplicate_fuel_level: 'Ensure No Duplicate Fuel Level',
    no_access: 'No Access',
    plate_no_asc: 'Plate No(ASC)',
    plate_no_desc: 'Plate No(DESC)',
    elock: 'ELock',
    updated_on: 'Updated on',
    view_fleet_details: 'View Fleet Details',
    fleet_monitoring_board: 'Fleet Monitoring Board',
    real_time_status_of_safevision_and_gps_assets: 'Real-Time Status of Safevision and GPS Assets',
    vehicle_offline: 'Vehicle Offline',
    safevision_offline: 'Safevision Offline',
    storage_warning: 'Storage Warning',
    start_ai_analysis: 'Start AI Analysis',
    offline_vehicle_monitor_more_than_12_hours: 'Offline Vehicle Monitor (More than 12 hours)',
    filter_and_share_online_status_reports_for_client_troubleshooting: 'Filter and Share Online Status Reports for Client Troubleshooting',
    search_vehicle_or_fleet: 'Search Vehicle or Fleet',
    server: 'Server',
    power_volt: 'Power/Volt',
    vehicle_plate_no: 'Vehicle Plate No',
    location_address: 'Location/Address',
    timestamp: 'Timestamp',
    copy_to_whatsapp: 'Copy to Whatsapp',
    of_fleet: 'of fleet',
    offline_gps_telematics: 'Offline GPS/Telematics',
    offline_safevision_mdvr: 'Offline Safevision/MDVR',
    last_seen: 'Last Seen',
    device_name: 'Device Name',
    handle_alert: 'Handle Alert',
    critical_alerts_log: 'Critical Alerts Log',
    active_storage_warnings: 'Active Storage Warnings',
    requires_attention: 'Requires Attention',
    memory_ssd_integrity: 'Memory/SSD Integrity',
    alert_type: 'Alert Type',
    message: 'Message',
    clear_all_alerts_log: 'Clear All Alerts Log?',
    clear_alerts_log_success: 'Clear Alerts Log Success',
    clear_alerts_log_cancel: 'Clear Alerts Log Cancel',
    remove_this_alert: 'Remove This Alert',
    remove_remark: 'Remove Remark',
    remove_alert_cancel: 'Remove Alert Cancel',
    accident_reconstruction_analysis_details: 'Accident Reconstruction Analysis Details',
    license_expiry: 'License Expiry',
    impact_time: 'Impact Time',
    accident_localization: 'Accident Localization',
    crash_reconstruction: 'Crash Reconstruction',
    accel_x: 'Accel X',
    accel_y: 'Accel Y',
    accel_z: 'Accel Z',
    x_g: 'X(G)',
    y_g: 'Y(G)',
    z_g: 'Z(G)',
    g_force: 'G Force',
    accident_logs: 'Accident Logs',
    high_frequecy_telemetry_capture_1ms: 'High-frequency Telemetry Capture (±1ms)',
    ms: 'MS',
    accident_reconstruction_analytics: 'Accident Reconstruction Analytics',
    fleet_wide_safety_performance_and_incident_monitoring: 'Fleet-wide Safety Performance and Incident Monitoring',
    fleet_safety_level: 'Fleet Safety Level',
    healthy_status: 'Healthy Status',
    active_vehicle: 'Active Vehicle',
    in_operation: 'In Operation',
    accident_count: 'Accident Count',
    verified_records: 'Verified Records',
    high_severity_rate: 'High Severity Rate',
    risk_alert: 'Risk Alert',
    incident_logs: 'Incident Logs',
    last_3_months: 'Last 3 Months',
    last_12_months: 'Last 12 Months',
    realtime_map_view: 'Real-Time Map View',
    safety_dashboard: 'Safety Dashboard',
    active_vehicles: 'Active Vehicles',
    accidents_count: 'Accidents Count',
    ivms_parameters: 'IVMS Parameters',
    driving_hour: 'Driving Hour',
    continuos_driving_hour: 'Continous Driving Hour',
    planned_order_hour: 'Planned Order Hour',
    working_hour: 'Working Hour',
    idle_duration_minute: 'Idle Duration (Minute)',
    unauthorized_stop_minute: 'Unauthorized Stop (Minute)',
    rest_hour: 'Rest Hour',
    lsr_violation_second: 'LSR Violation (Second)',
    rest_break_every_x_hour: 'Rest Break Every N Hour',
    rest_break_minute: 'Rest Break (Minute)',
    change_same_shift_hour: 'Change/Same Shift Hour',
    working_hour_per_week: 'Working Hour Per Week',
    driving_hour_per_week: 'Driving Hour Per Week',
    gps_tracker_source: 'GPS Tracker Source',
    default_source: 'Default Source',
    default_source_hint_default_title: 'Default',
    default_source_hint_default_primary: 'Uses the Primary Peripheral if available.',
    default_source_hint_default_tracker: 'Otherwise, uses the Tracker.',
    default_source_hint_peripheral_priority_title: 'Peripheral Priority',
    default_source_hint_peripheral_priority_any: 'Uses any Peripheral (Primary or General) if available.',
    default_source_hint_peripheral_priority_tracker: 'Otherwise, uses the Tracker.',
    default_source_hint_peripheral_priority_fuel: 'Except for Fuel-related reports (e.g., Fuel Consumption, Vehicle Summary, and ESG Report) always follow the Default source logic.',
    over_speeding_highway_km_h: 'Over Speeding Highway (Km/h)',
    over_speeding_highway_allowance_second: 'Over Speeding Highway Allowance (Second)',
    over_speeding_non_highway_km_h: 'Over Speeding Non Highway (Km/h)',
    over_speeding_non_highway_allowance_second: 'Over Speeding Non Highway Allowance (Second)',
    lsr_violation_speed_km_h: 'LSR Violation Speed (Km/h)',
    harsh_acceleration_kmh_per_sec: 'Harsh Acceleration (Km/h persec)',
    harsh_braking_kmh_per_sec: 'Harsh Braking (Km/h per sec)',
    harsh_turning_cornering_g: 'Harsh Turning Cornering (G)',
    vehicle_id: 'Vehicle ID',
    report_date: 'Report Date',
    mileage_in_km: 'Mileage In KM',
    total_data_count: 'Total Data Count',
    not_located_percent: 'Not Located Percent',
    network_disconnection_rate: 'Network Disconnection Rate',
    data_start_datetime: 'Data Start Datetime',
    data_end_datetime: 'Data End Datetime',
    reupload_count: 'Reupload Count',
    search_terminal_or_vehicle: 'Search Terminal or Vehicle',
    please_select_date_and_fleet_group: 'Please select Date and Fleet Group',
    search_by_route_name: 'Search by Route Name',
    route_name: 'Route Name',
    route_color: 'Route Color',
    route_radius: 'Route Radius (m)',
    assignment: 'Assignment',
    clear_and_replot: 'Clear and Replot',
    delete_route: 'Delete Route',
    update_route: 'Update Route',
    create_route: 'Create Route',
    add_route: 'Add Route',
    clustering: 'Clustering',
    searchAddress: 'Search Address',
    quickSearchAddress: 'Quick-search Address',
    pleaseEnterAddress: 'Please Enter an Address.',
    labelling: 'Labelling',
    banner_image_management: 'Banner Image Management',
    edit_banner: 'Edit Banner',
    display_date_range: 'Display Date Range',
    click_to_update_image: 'Click to update image',
    upload_new_banner: 'Upload New Banner',
    manage_dashboard_banner: 'Manage Dashboard Banner',
    preview: 'Preview',
    dimensions: 'Dimensions',
    uploaded_by: 'Uploaded By',
    uploaded_at: 'Uploaded At',
    please_wait_for_the_vehicle_to_be_online_to_view: 'Please wait for the vehicle to be online to view',
    recent_trip_log: 'Recent Trip Log',
    playback: 'Playback',
    driving_record: 'Driving Record',
    from: 'From',
    to: 'To',
    trip_detail: 'Trip Detail',
    delete_banner_image: 'Banner image deleted',
    banner_image_title: 'Banner Image Title',
    confirm_delete: 'Confirm Delete',
    please_leave_blank_for_using_the_default_vehicle: 'Please leave blank for using the default vehicle',
    choose_default_map_location: 'Choose Default Map Location',
    default_map_location: 'Default Map Location',
    preset_regions: 'Preset Regions',
    speed_mileage_chart: 'Speed and Mileage Chart',
    show_log: 'Show Log',
    hide_log: 'Hide Log',
}
